<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 受注一覧詳細画面 -->
      <div class="acceptEditForm" :style="{ height: basicHeight + 'px' }">
        <t-form
          label-position="right"
          :label-width="$t('widgetSize.ACCEPT_ORDER_INFO.DETIAL_LABEL_WIDTH')"
        >
          <!-- ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="受注基本情報" name="acceptOrderBasic">
              <!-- ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL"> </t-col>
                <!-- 見積No -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.QUOTE_NO')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="acceptEditForm.aobQuoteNo"
                      class="commonDialog"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- 得意先 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.CUS_NAME')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="acceptEditForm.aobCusCode"
                      class="commonDialog"
                      disabled
                    ></t-input>
                  </t-form-item>
                </t-col>
                <!-- 得意先担当者 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.CUS_USER_NAME')"
                    class="marginBottom"
                  >
                    <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="acceptEditForm.aobCusUserCode"
                      :disabled="cusUserSelectUseFlg || stateEndFlg"
                    >
                      <t-option
                        v-for="item in customerUserList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- 担当者 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.CONNECTER_NAME')"
                    class="marginBottom"
                  >
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="acceptEditForm.aobUserCode"
                  :disabled="stateEndFlg"
                > -->
                    <t-select
                      placeholder=""
                      class="commonDialog"
                      v-model="acceptEditForm.aobUserCode"
                      disabled
                    >
                      <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
                      <t-option
                        v-for="item in contacterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR"> &nbsp;</t-col>
              </t-row>

              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_備考機能の追加 -->
              <!-- <t-row
            type="flex"
            justify="center
          "
            style="height: 45px"
          > -->
              <t-row
                type="flex"
                justify="center"
                v-if="quoteType === '3'"
                style="height: 45px"
              >
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                <t-col :span="colArr.colL"> &nbsp;</t-col>

                <!-- DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_受注状態が非表示になる対応 -->
                <!-- 状態 -->
                <!-- <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.ACCEPT_ORDER.STATUS')"
                class="marginBottom"
              >
                <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="acceptEditForm.aobAcceptState"
                >
                  <t-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col> -->
                <!-- DEL 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->

                <!-- DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                <!-- 受注日 -->
                <!-- <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.ACCEPT_ORDER.ACCEPT_DATE')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="acceptEditForm.aobAcceptDate"
                  class="dialogDate"
                  :clearable="false"
                  :editable="false"
                  type="date"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :disabled="stateEndFlg"
                >
                </t-date-picker>
              </t-form-item>
            </t-col> -->
                <!-- DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->

                <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                <!-- <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="acceptEditForm.aobCusDeliveryDate"
                  class="dialogDate"
                  :editable="false"
                  :clearable="false"
                  type="date"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :disabled="stateEndFlg"
                  :placeholder="$t('resource.sys.hidden')"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>

            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.ACCEPT_ORDER.CUS_ORDER_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="acceptEditForm.aobCusOrderNo"
                  class="commonDialog"
                  maxlength="20"
                  :disabled="stateEndFlg"
                >
                </t-input>
              </t-form-item>
            </t-col> -->
                <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                <!-- タイプ -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.QUOTE_TYPE')"
                    class="marginBottom"
                    v-show="quoteType === '3'"
                  >
                    <t-input
                      v-model="quoteTypeVal"
                      class="commonDialog"
                      maxlength="20"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- ADD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                <!-- ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_受注状態が非表示になる対応 -->
                <t-col :span="colArr.colCom"> &nbsp;</t-col>
                <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
                <t-col :span="colArr.colCom"> &nbsp;</t-col>
                <t-col :span="colArr.colCom"> &nbsp;</t-col>
                <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->
                <t-col :span="colArr.colR"> &nbsp;</t-col>
              </t-row>

              <!-- ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓ -->
              <!-- 一式機能の追加 -->
              <t-row type="flex" justify="center" v-else>
                <t-col :span="colArr.colL"> </t-col>
                <!-- 一式 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.AOB_A_SET')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- <t-checkbox
                  v-model="acceptEditForm.aobASet"
                  style="line-height: 3"
                  @change="handleChange"
                  :disabled="stateEndFlg"
                /> -->
                    <t-checkbox
                      v-model="acceptEditForm.aobASet"
                      style="line-height: 3"
                      @change="handleChange"
                      :disabled="stateEndFlg || aSetEditFlg"
                    />
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                  </t-form-item>
                </t-col>
                <!-- 一式図番 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.AOB_A_SET_PROD_DRAW_NO')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->
                    <!-- 図番文字数：「30」⇒「50」 -->
                    <!-- <t-input
                      v-model="acceptEditForm.aobASetProdDrawNo"
                      class="commonDialog"
                      maxLength="30"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                    ></t-input> -->
                    <t-input
                      v-model="acceptEditForm.aobASetProdDrawNo"
                      class="commonDialog"
                      maxLength="50"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                    ></t-input>
                    <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->
                  </t-form-item>
                </t-col>
                <!-- 一式品名 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.AOB_A_SET_PROD_NAME')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓ -->
                    <!-- 品名、注番の変更： 文字数:「20」⇒「50」 -->
                    <!-- <t-input
                      v-model="acceptEditForm.aobASetProdName"
                      class="commonDialog"
                      maxLength="20"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                    ></t-input> -->
                    <t-input
                      v-model="acceptEditForm.aobASetProdName"
                      class="commonDialog"
                      maxLength="50"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                    ></t-input>
                    <!-- UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑ -->
                  </t-form-item>
                </t-col>
                <!-- 一式注番 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.AOB_A_SET_CUS_ORDER_NO')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓ -->
                    <!-- 品名、注番の変更： 文字数:「20」⇒「50」 -->
                    <!--
                    <t-input
                      v-model="acceptEditForm.aobASetCusOrderNo"
                      class="commonDialog"
                      maxLength="20"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                    ></t-input> -->

                    <t-input
                      v-model="acceptEditForm.aobASetCusOrderNo"
                      class="commonDialog"
                      maxLength="50"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                    ></t-input>
                    <!-- UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑ -->
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR"> &nbsp;</t-col>
              </t-row>

              <!-- ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑ -->

              <!-- ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->

              <t-row type="flex" justify="center" v-if="quoteType !== '3'">
                <t-col :span="colArr.colL"> </t-col>
                <t-col :span="colArr.colCom">
                  <!-- 一式確定売価 -->
                  <t-form-item
                    :label="$t('resource.ACCEPT_ORDER.AOB_A_SET_SALES_PRICE')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="acceptEditForm.aobASetSalesPrice"
                      class="commonDialog"
                      :disabled="stateEndFlg || aSetDisabledFlg"
                      :maxLength="8"
                      @focus="selectValue($event)"
                      @blur="changeASetSetPrice()"
                    ></t-input>
                  </t-form-item>
                  <!-- @input="
                    scope.row[column.prop] = scope.row[column.prop].replace(
                      /[^\d]/g,
                      ''
                    )
                  "
                  -->
                </t-col>
                <t-col :span="colArr.colCom * 3" />
                <t-col :span="colArr.colR"> &nbsp;</t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>
          <!-- ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->

          <t-row>
            <!-- 採番一覧選択 -->
            <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
            <!-- <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="col_common_left"
            >
              <t-button
                v-if="localIsAdd"
                round
                type="primary"
                class="dialogButton_120_40"
                ref="showNumberInfoBtn"
                :disabled="btnNumberInfoFlag || stateEndFlg"
                @click="showNumberInfoDialog"
              >
                <i class="el-icon-zoom-in"></i>
                {{ $t("resource.ACCEPT_ORDER.BTN_NUMBER_INFO") }}
              </t-button>
              <t-button
                v-else
                round
                type="primary"
                class="dialogButton_150_40"
                ref="showAcceptProductsBtn"
                :disabled="btnNumberInfoFlag || stateEndFlg"
                @click="showAcceptProductsDialog"
              >
                <i class="el-icon-zoom-in"></i>
                {{ $t("resource.ACCEPT_ORDER.BTN_ACCEPT_PRODUCT") }}
              </t-button>
            </t-col> -->
            <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

            <!-- 加工詳細 -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
              class="col_common_left"
            >
              <t-button
                type="primary"
                class="processButton_common"
                ref="process1Btn"
                style="margin-top: 5px"
                @click="showProcessDialog(1)"
                v-if="!btnProcess1Flag"
                :disabled="stateEndFlg"
              >
                {{ $t("resource.ACCEPT_ORDER.PROCESS_1") }}
                <i
                  class="el-icon-d-arrow-right"
                  v-if="
                    !btnProcess2Flag || !btnProcess3Flag || !btnProcess4Flag
                  "
                ></i> </t-button
            ></t-col>

            <!-- 処理1詳細 -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
              class="col_common_left"
            >
              <t-button
                type="primary"
                class="processButton_common"
                ref="process2Btn"
                style="margin-top: 5px"
                @click="showProcessDialog(2)"
                v-if="!btnProcess2Flag"
                :disabled="stateEndFlg"
              >
                {{ $t("resource.ACCEPT_ORDER.PROCESS_2") }}
                <i
                  class="el-icon-d-arrow-right"
                  v-if="!btnProcess3Flag || !btnProcess4Flag"
                ></i> </t-button
            ></t-col>

            <!-- 処理2詳細 -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
              class="col_common_left"
            >
              <t-button
                type="primary"
                class="processButton_common"
                ref="process3Btn"
                style="margin-top: 5px"
                @click="showProcessDialog(3)"
                v-if="!btnProcess3Flag"
                :disabled="stateEndFlg"
              >
                {{ $t("resource.ACCEPT_ORDER.PROCESS_3") }}
                <i
                  class="el-icon-d-arrow-right"
                  v-if="!btnProcess4Flag"
                ></i> </t-button
            ></t-col>

            <!-- 処理3詳細 -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
              class="col_common_left"
            >
              <t-button
                type="primary"
                class="processButton_common"
                ref="process4Btn"
                style="margin-top: 5px"
                @click="showProcessDialog(4)"
                v-if="!btnProcess4Flag"
                :disabled="stateEndFlg"
              >
                {{ $t("resource.ACCEPT_ORDER.PROCESS_4") }}
              </t-button></t-col
            >

            <!-- ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
            <!-- 一括至急の追加 -->
            <t-col :span="3" class="col_common_left">
              <template>
                <!-- 一括至急のチェックボックス -->
                <t-checkbox
                  v-model="allUrgentFlg"
                  @change="allUrgentCheckboxChange"
                  :label="$t('resource.ACCEPT_ORDER.SET_ALL_URGENT')"
                  style="line-height: 3; margin-top: 3px; margin-left: 5px"
                />
              </template>
            </t-col>
            <!-- ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->
            <!-- ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓ -->
            <t-col :span="3" class="col_common_left">
              <template>
                <!-- 編集列の選択ボックス -->
                <t-select
                  placeholder="編集列を選択する"
                  v-model="editingColumn"
                  class="input_icon_close"
                  style="margin-top: 10px"
                  clearable
                >
                  <t-option
                    v-for="item in editingList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </template>
            </t-col>
            <!-- ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑ -->
          </t-row>
        </t-form>
      </div>

      <!-- :summary-method="calculateTotalData"
      show-summary -->
      <div style="margin: 10px, 0">
        <!-- UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
        <!-- <t-table
          ref="acceptTableData"
          :data="acceptTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          highlight-current-row
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          :row-class-name="rowClassName"
          border
          fit
        > -->

        <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
        <!-- 課題_納期分割機能の追加 -->
        <!-- <t-table
          ref="acceptTableData"
          :data="acceptTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          highlight-current-row
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          :row-class-name="rowClassName"
          border
          fit
          row-key="id"
          default-expand-all
        > -->
        <t-table
          ref="acceptTableData"
          :data="acceptTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          highlight-current-row
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          :row-class-name="rowClassName"
          border
          fit
        >
          <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->

          <!-- UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
          <!-- @cell-click="editCellData" -->

          <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
          <!-- 画面と文字サイズの調整 -->
          <!-- <t-table-column
            v-for="(column, index) in acceptColumns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :fixed="index < 3"
            :header-align="column.headerAlign"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          > -->
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :fixed="index < 4"
            :header-align="column.headerAlign"
            :class-name="`${column.class} input_font_small`"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

            <template slot-scope="scope">
              <!-- UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
              <!--<t-input
                class="cell_input_custom"
                v-if="editCellData(scope.row, column) == 'input'"
                :maxLength="column.maxLength"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                @input="
                  scope.row[column.prop] = scope.row[column.prop].replace(
                    /[^\d]/g,
                    ''
                  )
                "
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @focus="changeCellDataToNumber(scope.row, column.prop)"
              />
              <t-input-number
                v-else-if="editCellData(scope.row, column) == 'inputNumber'"
                class="cell_input_number"
                :controls="false"
                :precision="0"
                :min="0"
                :max="999999"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
              ></t-input-number>-->

              <t-input
                class="cell_input_custom cell_input_font_small"
                v-if="editCellData(scope.row, column) == 'input'"
                :maxLength="column.maxLength"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                @input="
                  scope.row[column.prop] = scope.row[column.prop].replace(
                    /[^\d]/g,
                    ''
                  )
                "
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @focus="selectValue($event)"
              />
              <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
              <!-- 課題_納期分割機能の追加 -->
              <!-- <t-input-number
                v-else-if="editCellData(scope.row, column) == 'inputNumber'"
                class="cell_input_number cell_input_font_small"
                :controls="false"
                :precision="0"
                :min="-99999"
                :max="99999"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @focus="selectValue($event)"
              ></t-input-number> -->
              <t-input-number
                v-else-if="editCellData(scope.row, column) == 'inputNumber'"
                class="cell_input_number cell_input_font_small"
                :controls="false"
                :precision="0"
                :min="quoteType === '3' ? -99999 : 0"
                :max="99999"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @focus="selectValue($event)"
              ></t-input-number>
              <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->

              <!-- ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ -->
              <t-input-number
                v-else-if="editMsmNo(scope.row, column)"
                class="cell_input_number cell_input_font_small inputNumber-cell-left"
                style="text-align: right"
                :controls="false"
                :precision="0"
                :min="0"
                :max="9999"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @focus="selectValue($event)"
              ></t-input-number>
              <!-- ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->

              <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_備考機能の追加 -->
              <!-- <t-input
                v-else-if="remarksInputProc(scope.row, column)"
                maxLength="200"
                v-model="scope.row[column.prop]"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  remarksFocusNextInput(scope.row.index, column.prop)
                "
                class="cell_input_font_small"
                @focus="selectValue($event)"
              /> -->
              <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

              <!-- UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
              <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
              <t-date-picker
                v-else-if="cusDeliveryDateInputProc(scope.row, column)"
                v-model="scope.row[column.prop]"
                class="dialogDate cell_input_font_small"
                :clearable="false"
                type="date"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                :editable="false"
                :show-icon="false"
                :disabled="
                  scope.row.aodReduceKbnBool ||
                  scope.row.aodCloseStateVal !== '-'
                "
              >
              </t-date-picker>
              <t-input
                v-else-if="
                  editCellData(scope.row, column) == 'inputAodCusOrderNo'
                "
                :maxLength="column.maxLength"
                v-model="scope.row[column.prop]"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @blur="changeCellData()"
                class="cell_input_font_small"
                @focus="selectValue($event)"
              />
              <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

              <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_打合状態、納期の追加 -->
              <t-select
                placeholder=""
                class="commonDialog cell_input_font_small"
                v-else-if="column.prop == 'aodDiscussStatus'"
                v-model="scope.row[column.prop]"
                :disabled="
                  scope.row.aodReduceKbnBool ||
                  scope.row.aodCloseStateVal !== '-'
                "
              >
                <t-option
                  v-for="item in discussStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </t-option>
              </t-select>
              <!-- ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑ -->

              <!-- ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓ -->
              <!-- UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓ -->
              <!-- 納品先の追加 -->
              <!-- <t-select
                placeholder=""
                class="commonDialog cell_input_font_small"
                v-else-if="column.prop == 'aodCusDelvCode'"
                v-model="scope.row[column.prop]"
                :clearable="true"
                :disabled="
                  scope.row.aodReduceKbnBool ||
                  scope.row.aodCloseStateVal !== '-'
                "
              > -->

              <t-select
                placeholder=""
                class="commonDialog cell_input_font_small"
                v-else-if="
                  column.prop == 'aodCusDelvCode' &&
                  column.prop == editingColumn
                "
                v-model="scope.row[column.prop]"
                :clearable="true"
                :disabled="
                  scope.row.aodReduceKbnBool ||
                  scope.row.aodCloseStateVal !== '-'
                "
              >
                <!-- UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑ -->
                <t-option
                  v-for="item in getAbleDeliveryList(scope.row)"
                  :key="item.damCode"
                  :label="item.damName"
                  :value="item.damCode"
                >
                </t-option>
              </t-select>
              <!-- ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑ -->

              <!-- ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
              <!-- 課題_納期分割機能の追加 -->
              <t-checkbox
                v-model="scope.row[column.prop]"
                v-else-if="column.prop === 'aodReduceKbnBool'"
                @blur="changeCellData()"
                :disabled="checkBoxDisableProc(scope.row, column)"
              />
              <!-- ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->

              <!-- ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
              <!-- 緊急度の追加 -->
              <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
              <!-- 課題_納期分割機能の追加 -->
              <!-- <t-checkbox
                v-else-if="column.prop == 'aodUrgent' && scope.row.id < 10000"
                :checked="scope.row[column.prop] === '1'"
                :disabled="scope.row.aodReduceKbnBool"
                @change="(val) => (scope.row.aodUrgent = val ? '1' : '0')"
              /> -->

              <t-checkbox
                v-model="scope.row[column.prop]"
                v-else-if="
                  column.prop == 'aodUrgentBool' && scope.row.id < 10000
                "
                :disabled="
                  scope.row.aodReduceKbnBool ||
                  scope.row.aodCloseStateVal !== '-'
                "
              />
              <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->

              <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
              <t-checkbox
                v-model="scope.row[column.prop]"
                v-else-if="
                  column.prop == 'aodTreatmentBool' && scope.row.id < 10000
                "
                :disabled="
                  scope.row.aodReduceKbnBool ||
                  scope.row.aodCloseStateVal !== '-' ||
                  scope.row.aodTrtEditFlg
                "
              />

              <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

              <!-- @change="handleCheckChange(scope.row, column.prop, $event)" -->
              <!-- ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

              <span v-else>
                <!-- UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓ -->
                <!-- {{ scope.row[column.prop] }} -->
                <template v-if="column.prop == 'aodCusDelvCode'">
                  {{ getDelvName(scope.row.aodCusDelvCode) }}
                </template>
                <template v-else>
                  {{ scope.row[column.prop] }}
                </template>
                <!-- UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑ -->
              </span>
            </template>
          </t-table-column>

          <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
          <!-- 課題_備考機能の追加 -->
          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
          <!-- 共通備考の調整 -->
          <!-- <t-table-column
            :label="$t('resource.REMARKS_ADD.REMARKS')"
            prop="aodProdRemarksSum"
            :class-name="'cell_txt_center input_font_small'"
            :min-width="100"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.id < 10000" class="button-container">
                <t-tooltip placement="bottom" effect="light">
                  <div
                    class="tooltip-content"
                    slot="content"
                    v-html="formatRemarksShowProc(scope.row.aodProdRemarksSum)"
                  ></div>
                  <t-button
                    :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                    icon="el-icon-search"
                    size="small"
                    circle
                  >
                  </t-button>
                </t-tooltip>
                <t-button
                  type="warning"
                  icon="el-icon-edit"
                  size="small"
                  circle
                  @click="addRemarksProd(scope.row, $event)"
                ></t-button>
              </div>
              <span v-else> &nbsp;</span>
            </template>
          </t-table-column> -->
          <t-table-column
            :label="$t('resource.DUE_DATE_EDIT.REMARKS')"
            prop="aodProdRemarksSum"
            :class-name="'cell_txt_center input_font_small'"
            :width="getRemarksColumnWidthProc()"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.id < 10000" class="bikouDiv">
                <!-- 備考表示 -->
                <span class="bikouText">
                  {{ scope.row.aodProdRemarksSum }}
                </span>
                <!-- 備考編集 -->
                <t-button
                  type="warning"
                  icon="el-icon-edit"
                  size="small"
                  class="bikouButton"
                  circle
                  @click="showRemarksDialogProc(scope.row, $event)"
                ></t-button>
              </div>
            </template>
          </t-table-column>
          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

          <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

          <!-- ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
          <!-- 課題_納期分割機能の追加 -->
          <!-- 処理 ：「分割、補足、クローズ」ボタン-->
          <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
          <!-- <t-table-column
            :label="$t('resource.DUE_DATE_EDIT.TREATMENT')"
            :class-name="'cell_txt_center input_font_small'"
            :width="220"
            v-if="quoteType != '3'"
          > -->
          <t-table-column
            :label="$t('resource.DUE_DATE_EDIT.COUNT_CHANGE')"
            :class-name="'cell_txt_center input_font_small'"
            :width="220"
            v-if="quoteType != '3'"
          >
            <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
            <template slot-scope="scope">
              <div>
                <!-- 分割 -->
                <t-button
                  type="primary"
                  class="dialogButton_60"
                  size="small"
                  @click="showProdEditDialogProc(scope.row, '1', $event)"
                  :disabled="buttonCheck(scope.row, '1')"
                >
                  {{ $t("resource.DUE_DATE_EDIT.BTN_PROD_SPLIT") }}</t-button
                >

                <!-- 補足 -->
                <t-button
                  type="primary"
                  size="small"
                  class="dialogButton_60"
                  @click="showProdEditDialogProc(scope.row, '2', $event)"
                  :disabled="buttonCheck(scope.row, '2')"
                >
                  {{ $t("resource.DUE_DATE_EDIT.BTN_PROD_ADD") }}
                </t-button>

                <!-- クローズ -->
                <t-button
                  type="primary"
                  size="small"
                  class="dialogButton_80"
                  @click="showProdEditDialogProc(scope.row, '3', $event)"
                  :disabled="buttonCheck(scope.row, '3')"
                >
                  {{ $t("resource.DUE_DATE_EDIT.BTN_PROD_CLOSE") }}
                </t-button>
              </div>
            </template>
          </t-table-column>
          <!-- ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
        </t-table>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form>
          <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓ -->
           <!-- 小計売上の合計の追加 -->
          <t-row class="marginBottom">
            <t-col :span="19">&nbsp;</t-col>
            <!-- 合計(JPY) -->
            <t-col :span="5" class="col_common_right"
              ><t-input
                v-model="aodTotalSum"
                style="margin-left: 20px; margin-top: 5px; text-align: right"
                :disabled="true"
                class="sumInput"
              >
                <template slot="prepend">
                  <span class="span_style">{{
                    $t("resource.ACCEPT_ORDER.SUM")
                  }}</span></template
                >
              </t-input></t-col
            >
          </t-row>
          <!-- ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑ -->
          <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
          <!-- 課題_納期分割機能の追加 -->
          <!-- <t-row> -->
          <t-row type="flex" justify="end">
            <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
            <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
            <!-- <t-col :span="4" class="col_common_left"> -->
            <!-- 製品クローズ選択ボタン -->
            <!-- <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="productCloseSelectBtn"
                @click="productCloseSelectBtnProc"
                :disabled="stateEndFlg || localIsAdd"
              >
                <i class="el-icon-zoom-in"></i
                >{{ $t("resource.ACCEPT_ORDER.PRODUCT_CLOSE_SELECT") }}
              </t-button></t-col
            > -->
            <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

            <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
            <!-- 課題_納期分割機能の追加 -->
            <!-- <t-col :span="3" class="col_common_left"> -->
            <!-- 納品異常ボタン -->
            <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
            <!-- <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="deliveryExBtn"
                @click="deliveryExBtnProc"
                :disabled="stateEndFlg || localIsAdd
              > -->
            <!-- <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="deliveryExBtn"
                @click="deliveryExBtnProc"
                :disabled="stateEndFlg || localIsAdd || this.quoteType === '3'"
              > -->
            <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
            <!-- <i class="el-icon-s-order"></i
                >{{ $t("resource.ACCEPT_ORDER.DELIVERY_EX") }}
              </t-button></t-col
            > -->
            <!-- <t-col :span="1" class="right">&nbsp;</t-col>

            <t-col :span="3" class="col_common_left"> -->
            <!-- 製品数変更ボタン -->
            <!-- <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="qtyChangeBtn"
                @click="qtyChangeProc"
                :disabled="qtyChangeShowFlg"
              >
                <i class="el-icon-edit"></i
                >{{ $t("resource.button.quote_qty_change_btn") }}
              </t-button></t-col
            >
            <t-col :span="10" class="right">&nbsp;</t-col>
            -->

            <!-- ADD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
            <!-- <t-col :span="4">&nbsp;</t-col> -->
            <!-- ADD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

            <t-col :span="24" class="right">
              <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="acceptOrderConfirmBtn"
                :disabled="confirmButtonFlg"
                @click="acceptOrderConfirm"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
            <!-- DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
            <!-- 課題_納期分割機能の追加 -->
            <!-- <t-col :span="1">&nbsp;</t-col> -->
            <!-- DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowAcceptProductsDialog,
  ShowDeliveryExDialog,
  ShowDueDateEditDialog,
  ShowNumberInfoDialog,
  ShowProcessDialog,
  ShowProductCloseSelectDialog,
  ShowProductQtyChangeDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  addAcceptOrderDetail,
  addReacceptOrderDetail,
  getAcceptDetailInfoFromNumber,
  getInitInfoList,
  searchAcceptOrderDetailByAcceptOrderNo,
  updateAcceptOrderDetail,
} from "@/services/acceptOrder";
import { showRemarksDialog, showRemarksUpdDialog } from "@/services/common";
import {
  cmpBasicData,
  cmpDetailData,
  formatCurDateToString,
  formatCurrencyToNumber,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  formatStringToWeight,
  formatUndefinedToDate,
  getAbleCusDeliveryList,
  getAbleUserInfoList,
  getDialogContentHeight,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  AOB_ORDER_STATUS_ORDERED,
  DIALOG_LINE_HEIGHT,
  MSM_DL_KBN,
  NB_PROC_KBN_TRUE,
  NORMAL_PROD,
  NUM_ONE,
  NUM_ZERO,
  STR_EMPTY,
  STR_FIVE,
  STR_FOUR,
  STR_HYPHEN,
  STR_NOT_RCV,
  STR_ONE,
  STR_RCV_OVER,
  STR_THREE,
  STR_TWO,
  STR_URGENT_ONE,
  STR_URGENT_ZERO,
  STR_ZERO,
  UNIT_SET,
} from "@/utils/const";
//import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  computed: {},

  data() {
    return {
      //比較用基本情報
      cmpBasicResult: {},
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      activeNames: ["acceptOrderBasic"],
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      //基本情報のheight
      // basicHeight: DIALOG_LINE_HEIGHT * 3,
      //明細情報のheight
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 3,
      //   DIALOG_LINE_HEIGHT * 1,
      //   20
      // ),
      // UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      // // 基本情報のheight
      // basicHeight: DIALOG_LINE_HEIGHT * 2,
      // // 明細情報のheight
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 2,
      //   DIALOG_LINE_HEIGHT * 1,
      //   10
      // ),
      // 基本情報のheight
      basicHeight: 49 + DIALOG_LINE_HEIGHT * 3,
      // 明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        49 + DIALOG_LINE_HEIGHT * 4,
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // 小計売上の合計の追加
        // DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 2,
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        20
      ),
      // UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 小計売上の合計の追加
      // bottomHeight: DIALOG_LINE_HEIGHT * 1,
      bottomHeight: DIALOG_LINE_HEIGHT * 2,
      // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 小計売上の合計の追加
      //合計
      aodTotalSum: NUM_ZERO,
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      //受注状態
      statusList: [],

      //製品異常区分
      prodExKbnList: [],

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //　見積ターブル　0：製品、1：設計、3：補足
      quoteType: "0",
      quoteTypeVal: "-",
      // 見積ターブルリスト
      quoteTypeList: [],
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 課題_打合状態、納期の追加
      // 打合状態リスト
      discussStatusList: [],
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      columns: [],
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      acceptColumns: [
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width150"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          class: "cell_txt_left",
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
          // 品名、注番文字数：「20」⇒「50」
          // maxLength: 20,
          maxLength: 50,
          // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // 幅：20文字数を表示する
          // width: t("widgetSize.tableCommon.width150"),
          width: t("widgetSize.tableCommon.width220"),
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          class: "cell_txt_left",
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // 図番文字数：「30」⇒「50」
          // maxLength: 30,
          maxLength: 50,
          // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          overflowTooltip: true,
        },

        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 受注数位置の変更：「単位」列の前に移動する
        // 受注数
        {
          prop: "aodProdQuantity",
          label: t("resource.ACCEPT_ORDER.ACCEPT_COUNT"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_right",
        },
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.width80"),
          width: t("widgetSize.tableCommon.width60"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          class: "cell_txt_center",
          overflowTooltip: true,
        },

        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 製品の形状の追加
        // 形状
        {
          prop: "aodProdShape",
          label: t("resource.COMMON_CONSTANT.SHAPE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          maxLength: 20,
          overflowTooltip: true,
        },
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // 形状
        // {
        //   prop: "aodProdShape",
        //   label: t("resource.COMMON_CONSTANT.SHAPE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: true,
        // },
        // // 素材
        // {
        //   prop: "aodProdMaterial",
        //   label: t("resource.COMMON_CONSTANT.MATERIAL"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // // 処理
        // {
        //   prop: "aodProdTreatment",
        //   label: t("resource.COMMON_CONSTANT.TREATMENT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        // 重量(kg/個)
        {
          prop: "aodUWeight",
          label: t("resource.COMMON_CONSTANT.WEIGHT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 緊急度の追加
        {
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          // prop: "aodUrgent",
          prop: "aodUrgentBool",
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          label: t("resource.ACCEPT_ORDER.AOD_URGENT"),
          width: t("widgetSize.tableCommon.width60"),
          align: "center",
        },
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 得意先納期
        {
          prop: "aodCusDeliveryDate",
          label: t("resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE"),
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.width170"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },
        // 得意先納期履歴
        {
          prop: "aodCusDeliveryDateHistory",
          label: t("resource.ACCEPT_ORDER.AOD_CUS_DELIVERY_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 納品先の追加
        {
          prop: "aodCusDelvCode",
          label: t("resource.ACCEPT_ORDER.DELI_ADDR"),
          width: t("widgetSize.tableCommon.width150"),
          // UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
          //class: "cell_txt_right",
          class: "cell_txt_left",
          overflowTooltip: true,
          // UPD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
        },
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

        // 注番
        {
          prop: "aodCusOrderNo",
          label: t("resource.ACCEPT_ORDER.CUS_ORDER_NO"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.width120"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
          // 品名、注番文字数：「20」⇒「50」
          // maxLength: 20,
          maxLength: 50,
          // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
        },

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ACCEPT_ORDER.MSM_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },

        // ミスミ連携番号
        {
          prop: "aodMisumiNo",
          label: t("resource.ACCEPT_ORDER.MSM_NO"),
          width: t("widgetSize.tableCommon.width90"),
          maxLength: 4,
          class: "cell_txt_left",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 受注数位置の変更：「単位」列の前に移動する
        // // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        // // 受注数
        // {
        //   prop: "aodProdQuantity",
        //   label: t("resource.ACCEPT_ORDER.ACCEPT_COUNT"),
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        //   // 画面と文字サイズの調整
        //   // width: t("widgetSize.tableCommon.defaultWidth"),
        //   width: t("widgetSize.tableCommon.width60"),
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        //   class: "cell_txt_right",
        // },
        // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

        // クローズ数
        // {
        //   prop: "aodProdCloseQty",
        //   label: t("resource.ACCEPT_ORDER.CLOSE_COUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        // },

        // 粗利率(%)
        {
          prop: "aodGrossMargin",
          label: t("resource.numberEditInfo.ndiGrossMargin"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.defaultWidth"),
          width: t("widgetSize.tableCommon.width80"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },

        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // //売価
        // {
        //   prop: "aodUSalesPrice",
        //   label: t("resource.ACCEPT_ORDER.SALES_U_PRICE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        //   overflowTooltip: true,
        //   // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        // },
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

        //確定売価
        {
          prop: "aodUSetPrice",
          label: t("resource.ACCEPT_ORDER.SET_U_PRICE"),
          class: "cell_txt_right",
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // width: t("widgetSize.tableCommon.defaultWidth"),
          // maxLength: 6,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.tableCommon.width120"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          maxLength: 8,
          // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 受注日
        {
          prop: "aodAcceptDate",
          label: t("resource.ACCEPT_ORDER.ACCEPT_DATE"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: t("widgetSize.tableCommon.defaultWidth"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        //仕入価格
        {
          prop: "aodUPurchasePrice",
          label: t("resource.ACCEPT_ORDER.PURCHASE_U_PRICE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          maxLength: 6,
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          overflowTooltip: true,
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },
        //粗利
        {
          prop: "aodUGrossProfit",
          label: t("resource.ACCEPT_ORDER.GROSS_U_PROFIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          overflowTooltip: true,
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },
        // 小計売上
        {
          prop: "aodTotSalesPrice",
          label: t("resource.ACCEPT_ORDER.SALES_TOTAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          overflowTooltip: true,
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },
        // 小計粗利
        {
          prop: "aodTotGrossProfit",
          label: t("resource.ACCEPT_ORDER.GROSS_PROFIT_TOTAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          overflowTooltip: true,
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        },
        // 小計重量
        {
          prop: "aodTotWeight",
          label: t("resource.ACCEPT_ORDER.WEIGHT_TOTAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_打合状態、納期の追加
        // 打合状態
        {
          prop: "aodDiscussStatus",
          label: t("resource.ACCEPT_ORDER.PROD_DISCUSS_STATUS"),
          width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_right",
        },
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

        // // 異常区分
        // {
        //   prop: "aodProdExKbnVal",
        //   label: t("resource.ACCEPT_ORDER.PRODUCT_EX_KBN"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        // },
        // // 異常件数
        // {
        //   prop: "aodProdExQtyVal",
        //   label: t("resource.ACCEPT_ORDER.ANOMALY_COUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        // },

        // // 補足件数
        // {
        //   prop: "aodProdSuppQtyVal",
        //   label: t("resource.ACCEPT_ORDER.SUPPLEMENT_COUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        // },

        // DEL 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // クローズ状態
        // {
        //   prop: "aodCloseState",
        //   label: t("resource.ACCEPT_ORDER.CLOSE_STATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        // },
        // DEL 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // //備考
        // {
        //   prop: "aodProdRemarks",
        //   label: t("resource.ACCEPT_ORDER.REMARKS"),
        //   width: t("widgetSize.tableCommon.width170"),
        //   class: "cell_txt_left",
        // },
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加

        // 異常区分
        {
          prop: "aodProdExKbnVal",
          label: t("resource.ACCEPT_ORDER.PRODUCT_EX_KBN"),
          width: t("widgetSize.tableCommon.width90"),
          class: "cell_txt_center",
        },

        // 削減状態
        {
          prop: "aodReduceKbnBool",
          label: t("resource.DUE_DATE_EDIT.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
        },

        // クローズ状態
        {
          prop: "aodCloseStateVal",
          label: t("resource.ACCEPT_ORDER.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.width70"),
          class: "cell_txt_center",
        },
        // 入荷状態
        {
          prop: "aodRcvStatus",
          label: t("resource.ACCEPT_ORDER.PROD_RCV_STATUS"),
          width: t("widgetSize.tableCommon.width70"),
          class: "cell_txt_center",
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 列「処理」の追加
        {
          prop: "aodTreatmentBool",
          label: t("resource.DUE_DATE_EDIT.TREATMENT"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
        },
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      ],

      //得意先担当者
      customerUserList: [],
      //担当者
      contacterList: [],

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 納品先の追加
      cusDelvList: [],
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      userCusList: [],

      acceptEditForm: {
        aobQuoteNo: STR_EMPTY, //見積No.
        aobOldQuoteNo: STR_EMPTY, //旧見積No.
        aobCusCode: STR_EMPTY, //得意先
        aobCusUserCode: STR_EMPTY, //得意先担当者
        aobUserCode: STR_EMPTY, //担当者
        aobAcceptState: STR_EMPTY, //受注状態
        aobAcceptDate: STR_EMPTY, // 受注日

        // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
        // 一式機能の追加
        aobASet: false, //一式
        aobASetProdName: STR_EMPTY, //一式品名
        aobASetProdDrawNo: STR_EMPTY, //一式図番
        aobASetCusOrderNo: STR_EMPTY, //一式注番
        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        aobASetSalesPrice: STR_EMPTY, // 一式確定売価
        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // aobCusDeliveryDate: STR_EMPTY, // 納期
        // aobCusOrderNo: STR_EMPTY, // 注番
        aodCusDeliveryDate: STR_EMPTY, // 納期
        aodCusOrderNo: STR_EMPTY, // 注番
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        acceptUpdateTime: STR_EMPTY, //受注更新時刻
        numberUpdateTime: STR_EMPTY, //採番更新時刻
        isAdd: false, //画面区分
        aobProcKbn: STR_EMPTY, //プロセス区分
      },

      //受注タブのテーブル
      acceptTableData: [],

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //受注詳細製品(データ保存用)
      acceptTableInfo: [],
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      maxheight: t("widgetSize.orderEditDialog.tableHeight"),

      //加工詳細ボタン
      btnProcess1Flag: true,

      //処理1ボタン
      btnProcess2Flag: true,

      //処理2ボタン
      btnProcess3Flag: true,

      //処理3ボタン
      btnProcess4Flag: true,

      //採番一覧選択ボタン:　使用可能
      btnNumberInfoFlag: false,

      //得意先担当者コンボボックス: false:使用可能 true:使用不可
      // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // cusUserSelectUseFlg: true,
      cusUserSelectUseFlg: false,
      // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      allUrgentFlg: false,
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      //現在選択されているセル
      //currentCell: null,

      //画面状態：true:新規　false:編集
      localIsAdd: this.isAdd,

      //true:再度受注 false:受注
      isReacceptFlg: false,

      //true:確定ボタンが使用不可
      confirmButtonFlg: true,

      //false:状態が終了以外の場合、画面使用可
      stateEndFlg: false,

      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //editableColumns: ["aodProdQuantity", "aodUSetPrice", "aodProdCloseQty"],
      //編集可能な列
      editableColumns: [
        "aodProdQuantity",
        "aodUSetPrice",
        "aodProdCloseQty",
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 注番：編集し続けられる
        // "aodCusOrderNo",
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        "aodProdShape", //製品の形状の追加
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 「品名、図番」：編集可能
        "aodProdName",
        "aodProdDrawNo",
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      ],
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      //クローズ状態リスト
      closeStateList: [],

      //カバー層のフラップ false:表示しない
      showFlag: false,

      qtyChangeShowFlg: true,

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 注番の列幅フラグ（true:増加）
      aodCusOrderNoWidthFlg: false,
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      strUrgentZero: STR_URGENT_ZERO,
      strUrgentOne: STR_URGENT_ONE,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加　false:使用可能 true:使用不可
      aSetDisabledFlg: true,

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 一式のチェックボックスのフラグ
      aSetEditFlg: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      editingColumn: "",
      editingList: [
        //品名
        {
          value: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
        },
        //図番
        {
          value: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
        },
        //受注数
        {
          value: "aodProdQuantity",
          label: t("resource.ACCEPT_ORDER.ACCEPT_COUNT"),
        },
        //形状
        {
          value: "aodProdShape",
          label: t("resource.COMMON_CONSTANT.SHAPE"),
        },
        //得意先納期
        {
          value: "aodCusDeliveryDate",
          label: t("resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE"),
        },
        //納品先
        {
          value: "aodCusDelvCode",
          label: t("resource.ACCEPT_ORDER.DELI_ADDR"),
        },
      ],
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },
  mounted() {
    this.init(this.rowData);

    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    this.changeColumns();
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  watch: {
    "acceptEditForm.aobQuoteNo"(value) {
      //見積No.が空の場合、確定ボタンが使用不可
      if (value == STR_EMPTY) {
        this.confirmButtonFlg = true;
      } else {
        this.confirmButtonFlg = false;
      }
    },

    "acceptEditForm.aobAcceptState"(value) {
      //終了
      if (value == 9) {
        this.stateEndFlg = true;
      } else {
        this.stateEndFlg = false;
      }
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    quoteType(newVal) {
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      this.changeColumns();
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      this.handleResize();
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 注番の列幅フラグ（true:増加）
    aodCusOrderNoWidthFlg() {
      this.acceptColumns = this.acceptColumns.map((col) => {
        //注番
        if (col.prop === "aodCusOrderNo") {
          return {
            ...col,
            width: this.aodCusOrderNoWidthFlg ? 210 : 120,
          };
        }
        return col;
      });
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // 小計売上の合計の追加
    "acceptEditForm.aobASet"(value) {
      var tempValueSum = NUM_ZERO;
      //合計(CNY)
      if (value) {
        tempValueSum = formatCurrencyToNumber(
          this.acceptEditForm.aobASetSalesPrice
        );
      } else {
        this.acceptTableData.forEach((row) => {
          tempValueSum += formatCurrencyToNumber(row.aodTotSalesPrice);
        });
      }
      this.aodTotalSum = formatStringToCurrency(tempValueSum);
    },

    "acceptEditForm.aobASetSalesPrice"(value) {
      //合計(CNY)
      if (this.acceptEditForm.aobASet) {
        var tempValueSum = formatCurrencyToNumber(value);
        this.aodTotalSum = formatStringToCurrency(tempValueSum);
      }
    },
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // // 課題_備考機能の追加
      // // this.detailHeight = getDialogContentHeight(
      // //   window.innerHeight,
      // //   DIALOG_LINE_HEIGHT * 3,
      // //   DIALOG_LINE_HEIGHT * 1,
      // //   20
      // // );
      // // 基本情報のheight
      // // UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // //一式機能の追加
      // // this.basicHeight =
      // //   this.quoteType === "3"
      // //     ? DIALOG_LINE_HEIGHT * 3
      // //     : DIALOG_LINE_HEIGHT * 2;
      // this.basicHeight = DIALOG_LINE_HEIGHT * 3;
      // // UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
      // // 明細情報のheight
      // this.detailHeight = getDialogContentHeight(
      //   window.innerHeight,
      //   this.basicHeight,
      //   DIALOG_LINE_HEIGHT * 1,
      //   10
      // );
      // // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      var val = this.activeNames;

      if (val.indexOf("acceptOrderBasic") !== -1) {
        this.basicHeight =
          this.quoteType === "3"
            ? 49 + DIALOG_LINE_HEIGHT * 3
            : 49 + DIALOG_LINE_HEIGHT * 4;
        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          this.basicHeight,
          // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 小計売上の合計の追加
          // DIALOG_LINE_HEIGHT * 1,
          DIALOG_LINE_HEIGHT * 2,
          // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
          20
        );
      } else {
        this.basicHeight = 49 + DIALOG_LINE_HEIGHT;

        this.detailHeight = getDialogContentHeight(
          window.innerHeight,
          this.basicHeight,
          // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
          // 小計売上の合計の追加
          // DIALOG_LINE_HEIGHT * 1,
          DIALOG_LINE_HEIGHT * 2,
          // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
          15
        );
      }
      // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },
    // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

    //合計データの計算
    calculateTotalData(param) {
      //param意味がない場合は、合計処理を実施しない
      if (!param) {
        return;
      }

      const { columns, data } = param;

      //合計可能の列
      const totalColumns = [
        "aodProdQuantity",
        "aodTotSalesPrice",
        "aodTotGrossProfit",
        "aodTotWeight",
      ];

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合計";
          return;
        }

        if (totalColumns.includes(column.property)) {
          //通貨⇒数字の変換
          const values = data.map((item) =>
            formatCurrencyToNumber(item[column.property])
          );

          //数値ではない、または数値に変換できない内容がある
          if (!values.every((value) => isNaN(value))) {
            //初期値：0
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            //通貨の項目　数字⇒通貨の変換
            if (
              column.property == "aodTotSalesPrice" ||
              column.property == "aodTotGrossProfit"
            ) {
              sums[index] = formatStringToCurrency(sums[index]);
            }
            //合計結果が0の場合、空を表示する
            if (sums[index] == 0) {
              sums[index] = STR_EMPTY;
            }
          } else {
            sums[index] = STR_EMPTY;
          }
        }
      });

      return sums;
    },

    //セルデータの保存
    changeCellData() {
      //this.currentCell = null;

      this.dataProcess();

      //this.calculateTotalData();

      //setColumnWidth(this.acceptColumns, this.acceptTableData);
    },

    //セルデータの編集
    editCellData(row, column) {
      //注文済みの製品編集不可(クローズ数が編集可); クローズ数:正常製品入力可能、異常製品入力不可
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (
      //   (row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED &&
      //     column.prop != "aodProdCloseQty") ||
      //   (row.aodProdExKbn != "-" &&
      //     row.aodProdExKbn != this.prodExKbnList[0].value)
      // ) {
      //   return false;
      // }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (
      //   row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED ||
      //   row.childrenCount > 1 ||
      //   row.requestFlg === STR_ONE
      // ) {
      //   return;
      // }

      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      // 編集列のみコントロールを表示する
      if (
        this.editingList.some((item) => item.value === column.prop) &&
        column.prop != this.editingColumn
      ) {
        return false;
      }
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 形状:いつでも変更可能
      if (column.prop == "aodProdShape") {
        if (!(row.aodReduceKbnBool || row.aodCloseStateVal !== "-")) {
          if (row.id >= 10000) {
            return false;
          }
          return "inputAodCusOrderNo";
        }
      }
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 「品名、図番」：編集可能
      if (column.prop == "aodProdName" || column.prop == "aodProdDrawNo") {
        if (!(row.aodReduceKbnBool || row.aodCloseStateVal !== "-")) {
          if (row.id >= 10000) {
            return false;
          }
          return "inputAodCusOrderNo";
        }
      }
      if (column.prop == "aodCusOrderNo") {
        if (!(row.aodReduceKbnBool || row.aodCloseStateVal !== "-")) {
          if (row.id >= 10000) {
            return false;
          }
          return "inputAodCusOrderNo";
        }
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      if (
        row.requestFlg === STR_ONE ||
        row.aodRcvStatus !== STR_NOT_RCV ||
        row.aodReduceKbnBool ||
        row.aodCloseStateVal !== "-"
      ) {
        return;
      }

      if (row.aodProdExKbnVal != NORMAL_PROD) {
        return;
      }

      if (
        row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED &&
        column.prop !== "aodProdQuantity"
      ) {
        return;
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      if (!this.editableColumns.includes(column.prop)) {
        return false;
      }

      //状態が終了の場合、画面使用不可
      if (this.stateEndFlg) {
        return false;
      }

      if (column.prop == "aodUSetPrice") {
        //クローズの場合、編集不可
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // if (row.aodCloseState != "-") {
        //   return false;
        // }

        if (row.id >= 10000) {
          return false;
        }
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 金額：分割・補足・削減後、データの金額が変更不可
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // if (row.priceChangeFlg === STR_ONE) {

        if (
          row.priceChangeFlg === STR_ONE ||
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // 一式機能の追加
          (this.aSetEditFlg && row.aodProdUnit !== UNIT_SET) ||
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          // 「ミスミ以外とミスミ購入品」の場合、データの金額が変更可能
          // 「担当組付、社内組付、社内加工、ミスミ大連」の場合、データの金額が変更不可
          (row.aodMisumiKbn != STR_ZERO && row.aodMisumiKbn != STR_ONE)
        ) {
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
          return false;
        }
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        return "input";
      } else if (column.prop == "aodProdQuantity") {
        //クローズの場合、編集不可
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // if (row.aodCloseState != "-") {
        //   return false;
        // }

        // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (row.id >= 10000) {
        //   return false;
        // }
        // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        if (row.aodProdUnit === UNIT_SET && this.quoteType != "3") {
          return false;
        }
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        return "inputNumber";
      }
      // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 注番：編集し続けられる
      // // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // // 納期、注番の変更(見積単位⇒製品単位に変更)
      // else if (column.prop == "aodCusOrderNo") {
      //   if (row.id >= 10000) {
      //     return false;
      //   }
      //   return "inputAodCusOrderNo";
      // }
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // DEL 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // // 製品の形状の追加
      // else if (column.prop == "aodProdShape") {
      //   console.log("input");
      //   if (row.id >= 10000) {
      //     return false;
      //   }
      //   return "inputAodCusOrderNo";
      // }
      // // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      // DEL 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
      else {
        return false;
      }
    },

    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
    editMsmNo(row, column) {
      // ミスミ連携番号: クローズの場合、編集不可；削減の場合、編集不可;ミスミ以外・ミスミ購入品の場合、編集不可
      //　その他の場合、変更可能
      if (column.prop == "aodMisumiNo") {
        if (
          !row.aodReduceKbnBool &&
          row.aodCloseStateVal == "-" &&
          row.aodMisumiKbn !== STR_ZERO &&
          row.aodMisumiKbn !== STR_ONE
        ) {
          return true;
        }
      }
      return false;
    },
    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

    // 初期化
    init(data) {
      //待ちダイアログ表示
      this.showFlag = true;

      //受注情報の初期化
      this.infoInit(data);

      //列幅に自動調整
      //setColumnWidth(this.acceptColumns, this.acceptTableData);
    },

    //注文情報の初期化
    infoInit(data) {
      if (this.localIsAdd) {
        //新規
        this.acceptEditForm.isAdd = true;
      } else {
        //受注No
        this.acceptEditForm.aobQuoteNo = data.aobQuoteNo;
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        //得意先
        // this.acceptEditForm.aobCusCode = data.aobCusCode;
        this.acceptEditForm.aobCusCode = data.aobCusCodeStr;
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        //編集
        this.acceptEditForm.isAdd = false;
      }

      //基本情報のリスト取得（得意先担当者、担当者、状態）
      getInitInfoList(this.acceptEditForm).then((res) => {
        this.$nextTick(() => {
          //編集の場合、得意先担当者リストの取得
          if (!this.localIsAdd) {
            //得意先担当者リストの取得
            //得意先担当者リストのクリア
            this.customerUserList = [];

            res.aobCusUserCode.forEach((item) => {
              let newItem = {
                value: item.mgrCode,
                label: item.mgrAbbreviation,
              };
              //得意先担当者リストに追加
              this.customerUserList.push(newItem);
            });

            // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // 納品先の追加
            this.cusDelvList = [];

            res.cusDelvAddrList.forEach((item) => {
              let newItem = {
                damCode: item.damCode,
                damName: item.damName,
                damDelFlag: item.damDelFlag,
              };
              //得意先納品先リストに追加
              this.cusDelvList.push(newItem);
            });
            // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          }

          //担当者リストの取得
          this.contacterList = res.obUserCode;

          //受注状態
          this.statusList = res.aodStatusList;

          //製品異常区分
          this.prodExKbnList = res.prodExKbnList;

          //クローズ状態リストの取得
          this.closeStateList = res.closeStateList;

          this.userCusList = res.userCusList;

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // 見積ターブルリスト
          this.quoteTypeList = res.quoteTypeList;
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
          // 打合状態リスト
          this.discussStatusList = res.discussStatusList;
          // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

          //初期値の設定
          this.setInitValue();
        });
      });
    },

    //初期値の設定
    setInitValue() {
      //新規の場合
      if (this.localIsAdd) {
        //担当者
        this.acceptEditForm.aobUserCode = getUserInfo().UserId;
        this.getAbleList();
        //受注状態
        if (this.statusList.length > 0) {
          this.acceptEditForm.aobAcceptState = this.statusList[0].label;
        } else {
          this.acceptEditForm.aobAcceptState = "新規";
        }

        //受注日
        this.acceptEditForm.aobAcceptDate = new Date();

        //待ちダイアログを閉じる
        this.showFlag = false;
      } else {
        //編集の場合
        //受注No.による受注詳細情報の取得
        this.getAcceptOrderDetailByAcceptOrderNo();
      }
    },
    // 使用可能な担当者リストの取得
    getAbleList() {
      // 担当者リスト
      this.contacterList = getAbleUserInfoList(
        this.contacterList,
        this.acceptEditForm.aobUserCode
      );
    },
    //受注No.による受注詳細情報の取得
    getAcceptOrderDetailByAcceptOrderNo() {
      if (!this.showFlag) {
        this.showFlg = true;
      }

      let searchParams = {
        aobQuoteNo: this.acceptEditForm.aobQuoteNo,
        aobCusCode: this.acceptEditForm.aobCusCode,
      };

      searchAcceptOrderDetailByAcceptOrderNo(searchParams)
        .then((res) => {
          //得意先担当者
          this.acceptEditForm.aobCusUserCode =
            res.acceptOrderBasicForm.aobCusUserCode;
          //担当者
          this.acceptEditForm.aobUserCode =
            res.acceptOrderBasicForm.aobUserCode;
          this.getAbleList();
          //受注状態
          this.acceptEditForm.aobAcceptState =
            res.acceptOrderBasicForm.aobAcceptState;

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          //得意先
          this.acceptEditForm.aobCusCode = res.acceptOrderBasicForm.aobCusCode;

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

          //受注日
          this.acceptEditForm.aobAcceptDate = formatUndefinedToDate(
            res.acceptOrderBasicForm.aobAcceptDate
          );

          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 注番の列幅フラグ（true:増加）
          this.aodCusOrderNoWidthFlg = false;
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // //納期
          // this.acceptEditForm.aobCusDeliveryDate = formatUndefinedToDate(
          //   res.acceptOrderBasicForm.aobCusDeliveryDate
          // );

          // //注番
          // this.acceptEditForm.aobCusOrderNo =
          //   res.acceptOrderBasicForm.aobCusOrderNo;
          // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          // 受注更新時刻
          this.acceptEditForm.acceptUpdateTime = res.curAcceptUpdDateTime;

          // 採番更新時刻
          this.acceptEditForm.numberUpdateTime = res.curNumberUpdDateTime;

          // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
          // 一式機能の追加
          this.acceptEditForm.aobASet = res.acceptOrderBasicForm.aobASet; //一式

          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // this.aSetDisabledFlg = !this.acceptEditForm.aobASet;
          this.aSetEditFlg = res.acceptOrderBasicForm.aSetEditFlg;
          if (this.aSetEditFlg) {
            this.aSetDisabledFlg = this.aSetEditFlg;
          } else {
            this.aSetDisabledFlg = !this.acceptEditForm.aobASet;
          }
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          this.acceptEditForm.aobASetProdName =
            res.acceptOrderBasicForm.aobASetProdName; //一式品名
          this.acceptEditForm.aobASetProdDrawNo =
            res.acceptOrderBasicForm.aobASetProdDrawNo; //一式図番
          this.acceptEditForm.aobASetCusOrderNo =
            res.acceptOrderBasicForm.aobASetCusOrderNo; //一式注番

          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          this.acceptEditForm.aobASetSalesPrice = formatStringToCurrency(
            res.acceptOrderBasicForm.aobASetSalesPrice
          ); //一式確定売価
          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
          // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

          //プロセス区分
          this.acceptEditForm.aobProcKbn = res.acceptOrderBasicForm.aobProcKbn;

          //プロセスボタンの使用可能の設定
          if (this.acceptEditForm.aobProcKbn == null) {
            this.btnProcess1Flag = true;
            this.btnProcess2Flag = true;
            this.btnProcess3Flag = true;
            this.btnProcess4Flag = true;
          } else {
            for (var i = 0; i < this.acceptEditForm.aobProcKbn.length; i++) {
              if (this.acceptEditForm.aobProcKbn[i] === NB_PROC_KBN_TRUE) {
                if (i == 0) {
                  this.btnProcess1Flag = false;
                } else if (i == 1) {
                  this.btnProcess2Flag = false;
                } else if (i == 2) {
                  this.btnProcess3Flag = false;
                } else if (i == 3) {
                  this.btnProcess4Flag = false;
                }
              }
            }
          }

          //受注製品編集ボタンの使用フラグの設定
          this.btnNumberInfoFlag = res.isOrdered;

          this.acceptTableData = res.acceptOrderDetailInfoList;

          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          this.aodUpdateTime = res.curAcceptUpdDateTime;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          if (
            !!this.acceptTableData &&
            this.acceptTableData[0].aodQuoteType === STR_THREE
          ) {
            this.quoteType = STR_THREE;
            this.quoteTypeVal = this.quoteTypeList.find(
              (it) => it.value === this.quoteType
            )?.label;
          }

          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          this.allUrgentFlg = this.acceptTableData.every(
            (item) => item.aodUrgentBool
          );
          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          // Add  2024/12/31 JLS 課題_受注製品変更の検討 start↓
          // if (
          //   ((!!this.acceptTableData &&
          //     this.acceptTableData.some((data) => data.childrenCount > 1)) ||
          //     res.isOrdered) &&
          //   this.quoteType != STR_THREE
          // )
          if (res.isOrdered && this.quoteType != STR_THREE) {
            this.qtyChangeShowFlg = false;
          } else {
            this.qtyChangeShowFlg = true;
          }
          // Add  2024/12/31 JLS 課題_受注製品変更の検討 End

          this.dataProcess();

          //setColumnWidth(this.acceptColumns, this.acceptTableData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //採番情報から受注した詳細製品情報の取得
    getAcceptedDetailInfoFromNumber(target) {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //受注状態
      this.isReacceptFlg = target.isReaccept;

      getAcceptDetailInfoFromNumber(target)
        .then((res) => {
          //新規の場合
          if (this.localIsAdd) {
            //再度受注
            if (this.isReacceptFlg) {
              //見積No.
              this.acceptEditForm.aobQuoteNo =
                res.acceptOrderBasicForm.aobQuoteNo;
              //旧見積No.
              this.acceptEditForm.aobOldQuoteNo =
                res.acceptOrderBasicForm.aobOldQuoteNo;
              //得意先担当者コンボボックス:使用可能に変更
              this.cusUserSelectUseFlg = false;
            } else {
              //見積No.
              this.acceptEditForm.aobQuoteNo =
                res.acceptOrderBasicForm.aobQuoteNo;
            }

            //得意先
            this.acceptEditForm.aobCusCode =
              res.acceptOrderBasicForm.aobCusCode;

            //得意先担当者
            this.acceptEditForm.aobCusUserCode =
              res.acceptOrderBasicForm.aobCusUserCode;

            //受注状態
            this.acceptEditForm.aobAcceptState =
              res.acceptOrderBasicForm.aobAcceptState;

            //得意先担当者リストの取得
            //得意先担当者リストのクリア
            this.customerUserList = [];

            res.aobCusUserCode.forEach((item) => {
              let newItem = {
                value: item.mgrCode,
                label: item.mgrAbbreviation,
              };
              //得意先担当者リストに追加
              this.customerUserList.push(newItem);
            });

            //プロセス区分
            this.acceptEditForm.aobProcKbn =
              res.acceptOrderBasicForm.aobProcKbn;
          }

          // 採番更新時刻
          this.acceptEditForm.numberUpdateTime = res.curNumberUpdDateTime;

          this.acceptTableData = res.acceptOrderDetailInfoList;

          this.dataProcess();

          //列幅に自動調整
          //setColumnWidth(this.acceptColumns, this.acceptTableData);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //データの処理
    dataProcess() {
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 得意先納期履歴の列幅フラグ（true:増加）
      var historyChangeWidth = false;
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      this.acceptTableData.map((item) => {
        //受注数
        if (item.aodProdQuantity == undefined) {
          item.aodProdQuantity = 0;
        }
        // 小計重量
        item.aodTotWeight = formatStringToWeight(
          item.aodUWeight * item.aodProdQuantity
        );

        //クローズ数
        if (item.aodProdCloseQty == undefined) {
          item.aodProdCloseQty = 0;
        }

        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 注番
        if (item.aodCusOrderNo.length > 10) {
          //注番の列幅フラグ（true:増加）
          this.aodCusOrderNoWidthFlg = true;
        }
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        if (item.aodProdExKbn === STR_ZERO) {
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          //確定売価（JPY/个）
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          // if (item.aodUSetPrice == undefined) {
          // 「担当組付、社内組付、社内加工、ミスミ＿大連」の場合、確定売価が「０」を表示
          if (
            item.aodUSetPrice == undefined ||
            (item.aodMisumiKbn !== STR_ZERO && item.aodMisumiKbn !== STR_ONE)
          ) {
            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
            item.aodUSetPrice = 0;
          } else {
            item.aodUSetPrice = formatStringToCurrency(item.aodUSetPrice);
          }

          //小計売上
          item.aodTotSalesPrice = formatStringToCurrency(
            formatCurrencyToNumber(item.aodUSetPrice) * item.aodProdQuantity
          );

          // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // 売価が非表示の変更
          // //売価(JPY/个)
          // item.aodUSalesPrice = formatStringToCurrency(item.aodUSalesPrice);
          // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          // //粗利（JPY/个）
          // // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          // // item.aodUGrossProfit = formatStringToCurrency(
          // //   formatCurrencyToNumber(item.aodUSetPrice) - item.aodUPurchasePrice
          // // );
          // item.aodUGrossProfit = formatStringToCurrency(
          //   formatCurrencyToNumber(item.aodUSetPrice) -
          //     formatCurrencyToNumber(item.aodUPurchasePrice)
          // );
          // // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

          //小計粗利
          // item.aodTotGrossProfit = formatStringToCurrency(
          //   formatCurrencyToNumber(item.aodUGrossProfit) * item.aodProdQuantity
          // );

          //粗利の更新
          item = this.updProdGross(item);
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

          //クローズ状態の変換
          // item.aodCloseState = this.closeStateList.find(
          //   (it) => it.value === item.aodCloseState
          // )?.label;

          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          //仕入価格
          if (item.aodUPurchasePrice == undefined) {
            item.aodUPurchasePrice = 0;
          } else {
            item.aodUPurchasePrice = formatStringToCurrency(
              item.aodUPurchasePrice
            );
          }

          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // 粗利率％ = [1-(仕入価格(JPY)/確定売価]×100  (小数点以下2桁)　-99.99～100.00
          // 確定売価が０の場合、粗利率が０を表示する
          if (item.aodUSetPrice == 0) {
            item.aodGrossMargin = 0;
          } else {
            // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
            // 粗利率％ = [(粗利)/確定売価]×100  (小数点以下2桁)　-99.99～100.00
            // let grossMargin = parseFloat(
            //   (
            //     (1 -
            //       formatCurrencyToNumber(item.aodUPurchasePrice) /
            //         formatCurrencyToNumber(item.aodUSetPrice)) *
            //     100
            //   ).toFixed(2)
            // );

            let grossMargin = parseFloat(
              (
                (formatCurrencyToNumber(item.aodUGrossProfit) /
                  formatCurrencyToNumber(item.aodUSetPrice)) *
                100
              ).toFixed(2)
            );
            // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

            // 粗利率が-99.99以下の場合、「-99.99」」を表示する
            grossMargin = Math.max(-99.99, grossMargin);
            // 粗利率が100以上の場合、「100.00」を表示する
            grossMargin = Math.min(100, grossMargin);

            item.aodGrossMargin = grossMargin;
          }
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
        } else {
          item.aodUSetPrice = 0;

          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          item.aodGrossMargin = 0.0; // 粗利率％
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          //小計売上
          item.aodTotSalesPrice = 0;

          //売価(JPY/个)
          item.aodUSalesPrice = 0;
          //小計粗利
          item.aodUGrossProfit = 0;
          item.aodTotGrossProfit = 0;
          //仕入価格
          item.aodUPurchasePrice = 0;
        }
        // //クローズ状態の変換
        // item.aodCloseState = this.closeStateList.find(
        //   (it) => it.value === item.aodCloseState
        // )?.label;

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (item.children != null && item.children.length > 0) {
        //   //子項変更
        //   item.children.forEach((entity) => {
        //     //受注日
        //     entity.aodAcceptDate = formatDateToString(entity.aodAcceptDate);
        //     //重量
        //     entity.aodUWeight = null;
        //   });
        // } else {
        // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        //受注日
        item.aodAcceptDate = formatDateToString(item.aodAcceptDate);
        // }
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 閉じる後、得意先納期の変更チェック
        //得意先納期
        // item.aodCusDeliveryDate = formatUndefinedToDate(
        //   item.aodCusDeliveryDate
        // );
        item.aodCusDeliveryDate = formatDateToString(item.aodCusDeliveryDate);
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        //得意先納期履歴の列幅フラグ（true:増加）
        if (item.aodCusDeliveryDateHistory.includes("→")) {
          historyChangeWidth = true;
        }
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        item.aodProdExKbnVal = ShowMergeExKbn(
          item.aodProdExKbn,
          item.aodProdReceExKbn
        );
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        if (this.aSetEditFlg && item.aodProdUnit === UNIT_SET) {
          // 一式データが存在の場合
          // 基本データ：一式注番の更新
          this.acceptEditForm.aobASetCusOrderNo = item.aodCusOrderNo;
          // 一式品名の更新
          this.acceptEditForm.aobASetProdName = item.aodProdName;
          // 一式図番の更新
          this.acceptEditForm.aobASetProdDrawNo = item.aodProdDrawNo;

          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          // 一式確定売価
          this.acceptEditForm.aobASetSalesPrice = item.aodUSetPrice;
          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        }
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        return item;
      });

      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      // 小計売上の合計の追加
      //合計(CNY)
      var tempValueSum = NUM_ZERO;

      if (this.acceptEditForm.aobASet) {
        tempValueSum = this.acceptEditForm.aobASetSalesPrice;
      } else {
        this.acceptTableData.forEach((row) => {
          tempValueSum += formatCurrencyToNumber(row.aodTotSalesPrice);
        });
      }

      this.aodTotalSum = formatStringToCurrency(tempValueSum);
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // 納期の列幅フラグ（true:増加）
      this.acceptColumns = this.acceptColumns.map((col) => {
        if (col.prop === "aodCusDeliveryDateHistory") {
          return { ...col, width: historyChangeWidth ? 210 : 120 };
        }
        return col;
      });
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      //読み込み回数=1
      if (this.numLoads == 1) {
        var tmpTableData = JSON.parse(JSON.stringify(this.acceptEditForm));
        tmpTableData.aobAcceptDate = formatDateToString(
          tmpTableData.aobAcceptDate
        );
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // tmpTableData.aobCusDeliveryDate = formatDateToString(
        //   tmpTableData.aobCusDeliveryDate
        // );
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //比較用詳細情報
        this.cmpBasicResult = JSON.parse(
          JSON.stringify(this.extractBasic(tmpTableData))
        );

        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extractDetail(this.acceptTableData))
        );
        this.numLoads = this.numLoads + 1;
      }
    },

    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
    // 製品粗利の更新
    updProdGross(item) {
      // ミスミ以外・ミスミ購入品の場合、粗利の計算
      if (item.aodMisumiKbn === STR_ZERO || item.aodMisumiKbn === STR_ONE) {
        // ミスミデータの小計粗利の計算
        const aodTotGrossProfit = this.acceptTableData
          .filter(
            (row) =>
              row.aodMisumiKbn !== STR_ZERO &&
              row.aodMisumiKbn !== STR_ONE &&
              row.aodMisumiNo === item.aodMisumiNo
          )
          .reduce(
            (sum, row) =>
              formatCurrencyToNumber(sum) +
              (formatCurrencyToNumber(row?.aodUSetPrice || 0) -
                formatCurrencyToNumber(row?.aodUPurchasePrice || 0)) *
                row.aodProdQuantity,
            0
          );

        //小計粗利
        item.aodTotGrossProfit = formatStringToCurrency(
          aodTotGrossProfit +
            (formatCurrencyToNumber(item.aodUSetPrice) -
              formatCurrencyToNumber(item.aodUPurchasePrice)) *
              item.aodProdQuantity
        );

        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // 全て日本入荷データが日本入荷異常を発生の場合、数量が0を変更する
        if (item.aodProdQuantity === null || item.aodProdQuantity == NUM_ZERO) {
          item.aodUGrossProfit = formatStringToCurrency(
            aodTotGrossProfit +
              formatCurrencyToNumber(item.aodUSetPrice) -
              formatCurrencyToNumber(item.aodUPurchasePrice)
          );
        } else {
          // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
          //粗利（JPY/个）
          item.aodUGrossProfit = formatStringToCurrency(
            formatCurrencyToNumber(item.aodTotGrossProfit) /
              item.aodProdQuantity
          );
        }
      } else {
        // ミスミの場合、粗利が「０」を設定
        //粗利（JPY/个）
        item.aodUGrossProfit = 0;

        //小計粗利
        item.aodTotGrossProfit = 0;
      }

      return item;
    },
    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //注文済みの製品編集不可(クローズ数が編集可); クローズ数:正常製品入力可能、異常製品入力不可
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (
      //   (row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED &&
      //     column.property != "aodProdCloseQty") ||
      //   (row.aodProdExKbn != "-" &&
      //     row.aodProdExKbn != this.prodExKbnList[0].value)
      // ) {
      //   return;
      // }

      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // 受注数＜０の場合、文字は赤を表示
      // if (
      //   (column.property === "aodProdQuantity" &&
      //     row.aodProdQuantity < 0 &&
      //     row.id >= 10000) ||
      //   (column.property === "aodTotSalesPrice" &&
      //     formatCurrencyToNumber(row.aodTotSalesPrice) < 0) ||
      //   (column.property === "aodUGrossProfit" &&
      //     formatCurrencyToNumber(row.aodUGrossProfit) < 0) ||
      //   (column.property === "aodTotGrossProfit" &&
      //     formatCurrencyToNumber(row.aodTotGrossProfit) < 0)
      // ) {
      //   return "txt-cell-editable_red";
      // }
      // if (
      //   column.property === "aodProdQuantity" &&
      //   row.aodProdQuantity < 0 &&
      //   row.id < 10000 &&
      //   (row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED ||
      //     row.requestFlg === STR_ONE)
      // ) {
      //   return "txt-cell-editable_red";
      // }
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      // 受注数＜０の場合、文字は赤を表示
      if (
        (column.property === "aodTotSalesPrice" &&
          formatCurrencyToNumber(row.aodTotSalesPrice) < 0) ||
        (column.property === "aodUGrossProfit" &&
          formatCurrencyToNumber(row.aodUGrossProfit) < 0) ||
        (column.property === "aodTotGrossProfit" &&
          formatCurrencyToNumber(row.aodTotGrossProfit) < 0)
      ) {
        return "txt-cell-editable_red";
      }

      // 課題_納期分割機能の追加
      if (row.aodReduceKbnBool) {
        if (column.property === "aodReduceKbnBool") {
          return "bg-cell-editable";
        } else {
          return;
        }
      }

      if (row.aodCloseStateVal !== "-") {
        return;
      }

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 形状：いつでも変更可能
      if (column.property === "aodProdShape") {
        return "bg-cell-editable";
      }
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 「品名、図番」：編集可能
      if (
        column.property === "aodProdName" ||
        column.property === "aodProdDrawNo" ||
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        column.property === "aodCusOrderNo"
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      ) {
        return "bg-cell-editable";
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      if (column.property === "aodCusDelvCode") {
        //編集可能の背景色
        return "bg-cell-editable";
      }
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // ミスミ連携番号: クローズの場合、編集不可；削減の場合、編集不可;ミスミ以外・ミスミ購入品の場合、編集不可
      //　その他の場合、変更可能
      if (column.property == "aodMisumiNo") {
        if (row.aodMisumiKbn !== STR_ZERO && row.aodMisumiKbn !== STR_ONE) {
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      if (column.property === "aodProdQuantity") {
        if (
          row.aodReduceKbnBool ||
          row.aodRcvStatus != STR_NOT_RCV ||
          row.requestFlg === STR_ONE ||
          row.aodProdExKbnVal != NORMAL_PROD ||
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          (row.aodProdUnit === UNIT_SET && this.quoteType != "3")
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        ) {
          return;
        } else {
          return "bg-cell-editable";
        }
      }

      if (
        column.property === "aodProdQuantity" &&
        row.aodProdQuantity < 0 &&
        (row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED ||
          row.requestFlg === STR_ONE)
      ) {
        return "txt-cell-editable_red";
      }

      if (row.aodProdExKbnVal != NORMAL_PROD) {
        if (column.property === "aodProdQuantity") {
          return;
        }
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      // 課題_打合状態の追加
      if (column.property === "aodDiscussStatus") {
        //編集可能の背景色
        return "bg-cell-editable";
      }
      // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加

      if (column.property === "aodReduceKbnBool") {
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 正常品の場合、削減区分が選択可能、異常品の場合、選択不可
        // if (
        //   row.aodProdExKbn !== STR_ZERO ||
        //   row.aodProdReceExKbn !== STR_ZERO
        // ) {
        // 納品異常データ・納品→入荷異常データの場合、選択不可；その他の場合、選択可能
        // 未入荷の場合、選択可能、以外の場合、選択不可
        if (row.aodProdExKbn !== STR_ZERO || row.aodRcvStatus !== STR_NOT_RCV) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          return;
        } else {
          return "bg-cell-editable";
        }
      }
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // if (column.property === "aodProdRemarks") {
      //   if (row.childrenCount > 1 && row.id < 10000) {
      //     return "bg-cell-editable_grey";
      //   } else {
      //     //編集可能の背景色
      //     return "bg-cell-editable";
      //   }
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 緊急度の追加
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (column.property === "aodUrgent") {
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // if (column.property === "aodUrgentBool") {
      if (
        column.property === "aodUrgentBool" ||
        (column.property === "aodTreatmentBool" && !row.aodTrtEditFlg)
      ) {
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (row.id >= 10000) {
        //   return "bg-cell-editable_grey";
        // } else {
        //   //編集可能の背景色
        //   return "bg-cell-editable";
        // }
        //編集可能の背景色
        return "bg-cell-editable";
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      }
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      if (column.property === "aodCusDeliveryDate") {
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // if (row.id >= 10000) {
        //   return "bg-cell-editable_grey";
        // } else {
        //   //編集可能の背景色
        //   return "bg-cell-editable";
        // }
        //編集可能の背景色
        return "bg-cell-editable";
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      }
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (column.property === "aodAcceptDate") {
      //   if (row.childrenCount > 1 && row.id < 10000) {
      //     return "bg-cell-editable_grey";
      //   }
      // }
      // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      if (
        row.aodOrderStatus == AOB_ORDER_STATUS_ORDERED ||
        row.requestFlg === STR_ONE
      ) {
        return;
      }
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      //状態が終了の場合、画面使用不可
      if (this.stateEndFlg) {
        return;
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (this.editableColumns.includes(column.property)) {
      //   //クローズの場合、編集不可
      //   if (row.aodCloseState != "-") {
      //     return;
      //   }

      //   //編集可能の背景色
      //   return "bg-cell-editable";
      // }

      if (this.editableColumns.includes(column.property)) {
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓

        // if (row.childrenCount <= 1) {
        //   //編集可能の背景色
        //   return "bg-cell-editable";
        // }

        //クローズの場合、編集不可
        // // 課題_納期分割機能の追加
        // if (row.id >= 10000) {
        //   if (column.property == "aodProdQuantity") {
        //     return;
        //   } else {
        //     return "bg-cell-editable_grey";
        //   }
        // }
        // 金額：分割・補足・削減後、データの金額が変更不可
        if (
          column.property == "aodUSetPrice" &&
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          // row.priceChangeFlg === STR_ONE
          (row.priceChangeFlg === STR_ONE ||
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // 一式データの場合、単位が「式」以外の項目の確定売価は入力不可
            (this.aSetEditFlg && row.aodProdUnit !== UNIT_SET) ||
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            // 「ミスミ以外とミスミ購入品」の場合、データの金額が変更可能
            // 「担当組付、社内組付、社内加工、ミスミ大連」の場合、データの金額が変更不可
            (row.aodMisumiKbn != STR_ZERO && row.aodMisumiKbn != STR_ONE))
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        ) {
          return;
        }

        //編集可能の背景色
        return "bg-cell-editable";
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      }
      // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      //   var columnColorFlg =
      //     row.id >= 10000 &&
      //     ((column.property == "aodProdName" && !row.aodProdName) ||
      //       (column.property == "aodProdDrawNo" && !row.aodProdDrawNo) ||
      //       (column.property == "aodProdUnit" && !row.aodProdUnit) ||
      //       (column.property == "aodProdShape" && !row.aodProdShape) ||
      //       (column.property == "aodProdMaterial" && !row.aodProdMaterial) ||
      //       (column.property == "aodProdTreatment" && !row.aodProdTreatment) ||
      //       (column.property == "aodUWeight" && !row.aodUWeight) ||
      //       // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      //       // 納期、注番の変更(見積単位⇒製品単位に変更)
      //       (column.property == "aodCusDeliveryDate" &&
      //         !row.aodCusDeliveryDate) ||
      //       (column.property == "aodCusDeliveryDateHistory" &&
      //         !row.aodCusDeliveryDateHistory) ||
      //       (column.property == "aodCusOrderNo" && !row.aodCusOrderNo) ||
      //       // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      //       (column.property == "aodGrossMargin" && !row.aodGrossMargin) ||
      //       (column.property == "aodUSalesPrice" && !row.aodUSalesPrice) ||
      //       (column.property == "aodUSetPrice" && !row.aodUSetPrice) ||
      //       (column.property == "aodUPurchasePrice" && !row.aodUPurchasePrice) ||
      //       (column.property == "aodUGrossProfit" && !row.aodUGrossProfit) ||
      //       // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
      //       // 課題_打合状態、納期の追加
      //       (column.property == "aodDiscussStatus" && !row.aodDiscussStatus) ||
      //       // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
      //       (column.property == "aodTotSalesPrice" && !row.aodTotSalesPrice) ||
      //       (column.property == "aodTotGrossProfit" && !row.aodTotGrossProfit) ||
      //       (column.property == "aodTotWeight" && !row.aodTotWeight) ||
      //       // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      //       // 課題_備考機能の追加
      //       // (column.property == "aodProdRemarks" && !row.aodProdRemarks));
      //       (column.property == "aodProdRemarksSum" && !row.aodProdRemarksSum));

      //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //   if (columnColorFlg) {
      //     return "bg-cell-editable_grey";
      //   }
      //   // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //入力チェック
    inputCheck() {
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // //納期の検証
      // if (formatCurDateToString(this.acceptEditForm.aobCusDeliveryDate) == "") {
      //   Modal.showWarning("", t("message.ACCEPT_ORDER.DUE_DATE_CHECK"), {
      //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //   });
      //   return false;
      // }
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      //製品情報はデータがある場合
      // if (this.acceptTableData.length > 0) {
      //   for (var index = 0; index < this.acceptTableData.length; index++) {
      //     const row = this.acceptTableData[index];
      //     //クローズ数の入力チェック
      //     if (
      //       formatCurrencyToNumber(row.aodProdCloseQty) >
      //       formatCurrencyToNumber(row.aodProdQuantity)
      //     ) {
      //       this.$message(
      //         t("message.ACCEPT_ORDER.CLOSEQTY_MORE_THAN_ACCEPTORDERQTY") +
      //           t("resource.ACCEPT_ORDER.CLOSE_COUNT") +
      //           t("message.input.hintAgain")
      //       );
      //       return false;
      //     }
      //   }
      // }

      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      if (!!this.acceptEditForm.aobASet) {
        //一式の場合、一式図番と一式品名には少なくとも1つの値がある
        if (
          this.isEmptyOrNull(this.acceptEditForm.aobASetProdDrawNo) &&
          this.isEmptyOrNull(this.acceptEditForm.aobASetProdName)
        ) {
          Modal.showWarning(
            "",
            t("message.ACCEPT_ORDER.DATA_ERROR")
              .replace("{0}", t("resource.ACCEPT_ORDER.AOB_A_SET_PROD_DRAW_NO"))
              .replace("{1}", t("resource.ACCEPT_ORDER.AOB_A_SET_PROD_NAME")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        // ADD 2026/02/06 Wjx 課題_260107顧客からの改善したい点への対応 start↓
        // 受注一式データのチェックの追加：一式データのすべて製品の確定売価は0であるべきです
        // すべて製品の確定売価が「0」のチェック
        const allZeroAodUSetPrice = this.acceptTableData.every(
          // UPD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
          // バグ修正
          //    (item) => item.aodUSetPrice == "0"

          (item) => {
            // 単位が「式」の場合、単価はチェックしない
            if (item.aodProdUnit === "式") {
              return true;
            }
            // 単位が「式」以外の場合、単価はチェックする
            return item.aodUSetPrice == "0";
          }
          // UPD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
        );
        if (!allZeroAodUSetPrice) {
          Modal.showWarning(
            "",
            t("message.ACCEPT_ORDER.A_SET_UNIT_DATA_CHECK"),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }
        // ADD 2026/02/06 Wjx 課題_260107顧客からの改善したい点への対応 end↑
      }
      // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      if (this.acceptTableData.length > 0) {
        // 重複しない連携noリストの取得
        const baseMisumiNos = new Set();
        for (const r of this.acceptTableData) {
          if (r.aodMisumiKbn === STR_ZERO || r.aodMisumiKbn === STR_ONE) {
            baseMisumiNos.add(r.aodMisumiNo);
          }
        }

        const DLMisumiNos = new Set();
        for (const r of this.acceptTableData) {
          if (
            (r.aodMisumiKbn === STR_ZERO || r.aodMisumiKbn === STR_ONE) &&
            r.aodMSupFactoryKbn == STR_ONE
          ) {
            DLMisumiNos.add(r.aodMisumiNo);
          }
        }

        for (var index = 0; index < this.acceptTableData.length; index++) {
          const row = this.acceptTableData[index];

          if (
            row.aodMisumiKbn !== STR_ZERO &&
            row.aodMisumiKbn !== STR_ONE &&
            !row.aodReduceKbnBool
          ) {
            // ミスミ連携番号が空のチェック
            if (this.isEmptyOrNull(row.aodMisumiNo)) {
              Modal.showWarning(
                "",
                "製品「" +
                  row.aodProdName +
                  " " +
                  row.aodProdDrawNo +
                  "」の" +
                  t("message.ACCEPT_ORDER.MSM_NO_CHECK"),
                {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                }
              );
              return false;
            }

            // ミスミ連携番号が範囲以外の場合
            if (!baseMisumiNos.has(row.aodMisumiNo)) {
              Modal.showWarning(
                "",
                "製品「" +
                  row.aodProdName +
                  " " +
                  row.aodProdDrawNo +
                  "」の" +
                  t("message.ACCEPT_ORDER.MSM_NO_CHECK"),
                {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                }
              );
              return false;
            }

            // ミスミ_大連の場合、ミスミ連携番号の仕入先が大連以外の場合、
            if (
              row.aodMisumiKbn == MSM_DL_KBN &&
              !DLMisumiNos.has(row.aodMisumiNo)
            ) {
              Modal.showWarning(
                "",
                "製品「" +
                  row.aodProdName +
                  " " +
                  row.aodProdDrawNo +
                  "」の" +
                  t("message.ACCEPT_ORDER.MSM_DL_NO_CHECK"),
                {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                }
              );
              return false;
            }
          }
        }
      }

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      return true;
    },
    //「確定」ボタン
    acceptOrderConfirm() {
      this.showFlag = true;

      if (this.inputCheck()) {
        //保存用データ処理
        //受注日
        this.acceptEditForm.aobAcceptDate = formatCurDateToString(
          this.acceptEditForm.aobAcceptDate
        );

        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //  //納期
        //   this.acceptEditForm.aobCusDeliveryDate = formatCurDateToString(
        //     this.acceptEditForm.aobCusDeliveryDate
        //   );
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        this.dataAddUpdProc();
        // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        if (this.localIsAdd) {
          //再度受注
          if (this.isReacceptFlg) {
            addReacceptOrderDetail({
              curNumberUpdDateTime: this.acceptEditForm.numberUpdateTime,
              acceptOrderBasicForm: this.acceptEditForm,
              acceptOrderDetailInfoList: this.acceptTableData,
              user: getUserInfo().UserId,
            })
              .then((res) => {
                Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));

                this.localIsAdd = false;

                this.isReacceptFlg = false;

                //得意先担当者コンボボックス:使用不可に変更
                this.cusUserSelectUseFlg = true;
                this.numLoads = 1;
                //検索処理を行う
                this.getAcceptOrderDetailByAcceptOrderNo();
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
                }
              });
          } else {
            //新規
            addAcceptOrderDetail({
              curNumberUpdDateTime: this.acceptEditForm.numberUpdateTime,
              acceptOrderBasicForm: this.acceptEditForm,
              acceptOrderDetailInfoList: this.acceptTableData,
              user: getUserInfo().UserId,
            })
              .then((res) => {
                Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));

                this.localIsAdd = false;
                this.numLoads = 1;
                //検索処理を行う
                this.getAcceptOrderDetailByAcceptOrderNo();
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
                }
              });
          }
        } else {
          // this.acceptTableData.map((item) => {
          //   item.aodProdCloseQty = isNaN(item.aodProdCloseQty) ? STR_EMPTY : 0;
          // });

          //更新
          updateAcceptOrderDetail({
            curNumberUpdDateTime: this.acceptEditForm.numberUpdateTime,
            curAcceptUpdDateTime: this.acceptEditForm.acceptUpdateTime,
            acceptOrderBasicForm: this.acceptEditForm,
            // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
            // acceptOrderDetailInfoList: this.acceptTableData,
            acceptOrderDetailInfoList: this.acceptTableInfo,
            // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

            isOrdered: this.btnNumberInfoFlag,
            user: getUserInfo().UserId,
          })
            .then((res) => {
              Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
              this.numLoads = 1;
            })
            .catch((err) => {
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
            })
            .finally(() => {
              //検索処理を行う
              this.getAcceptOrderDetailByAcceptOrderNo();
            });
        }
      } else {
        //検索処理を行う
        //this.getAcceptOrderDetailByAcceptOrderNo();
        this.showFlag = false;
      }

      // フォーカス削除
      this.$refs.acceptOrderConfirmBtn.$el.blur();
    },

    //タブ切り替え
    handleTabClick(tab, event) {},

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (
      //   row.aodProdExKbn != "-" &&
      //   row.aodProdExKbn != this.prodExKbnList[0].value
      // ) {
      //   return "textColor";
      // }
      if (row.aodProdExKbnVal != NORMAL_PROD) {
        return "textColor";
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    //採番一覧選択画面の表示
    showNumberInfoDialog() {
      ShowNumberInfoDialog(
        {},
        t("resource.ACCEPT_ORDER.NUMBER_INFO_DIALOG"),
        (target) => {
          if (target) {
            if (this.localIsAdd) {
              let params = {
                isAdd: this.localIsAdd,
                isReaccept: target.reacceptFlg,
                selectedAcceptProductList: target.acceptProductList,
              };

              this.getAcceptedDetailInfoFromNumber(params);
            }
          } else {
            this.init;
          }
        }
      );

      // フォーカス削除
      this.$refs.showNumberInfoBtn.$el.blur();
    },

    //受注製品選択画面の表示
    showAcceptProductsDialog() {
      ShowAcceptProductsDialog(
        {
          aobQuoteNo: this.acceptEditForm.aobQuoteNo,
          editTableData: this.acceptTableData,
        },
        t("resource.ACCEPT_ORDER.DIALOG_ACCEPT_PRODUCT_EDIT"),
        (target) => {
          if (target) {
            let params = {
              isAdd: this.localIsAdd,
              isReaccept: target.reacceptFlg,
              selectedAcceptProductList: target.acceptProductList,
            };
            this.getAcceptedDetailInfoFromNumber(params);
          } else {
            this.init;
          }
        }
      );

      // フォーカス削除
      this.$refs.showAcceptProductsBtn.$el.blur();
    },

    //処理詳細画面を表示
    showProcessDialog(procKbn) {
      //画面の名称
      var pageName;

      if (procKbn == 1) {
        pageName = t("resource.ACCEPT_ORDER.PROCESS_1");
        // フォーカス削除
        this.$refs.process1Btn.$el.blur();
      } else if (procKbn == 2) {
        pageName = t("resource.ACCEPT_ORDER.PROCESS_2");
        this.$refs.process2Btn.$el.blur();
      } else if (procKbn == 3) {
        pageName = t("resource.ACCEPT_ORDER.PROCESS_3");
        this.$refs.process3Btn.$el.blur();
      } else if (procKbn == 4) {
        pageName = t("resource.ACCEPT_ORDER.PROCESS_4");
        this.$refs.process4Btn.$el.blur();
      }

      ShowProcessDialog(
        {
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 Start↓
          quoteType: this.quoteType,
          //ADD 2025/01/02 Wzc 課題_仕様変更の対応 End↑
          procKbn: procKbn,
          acceptData: this.acceptEditForm,
        },
        pageName,

        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // コンソールエラーの解決
        // (this.numLoads = 1),
        // this.getAcceptOrderDetailByAcceptOrderNo

        (target) => {
          this.numLoads = 1;
          this.getAcceptOrderDetailByAcceptOrderNo();
        }
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      );
    },

    //製品クローズ選択画面を表示
    productCloseSelectBtnProc() {
      // フォーカス削除
      this.$refs.productCloseSelectBtn.$el.blur();

      ShowProductCloseSelectDialog(
        {
          aobQuoteNo: this.acceptEditForm.aobQuoteNo,
        },
        t("resource.ACCEPT_ORDER.PRODUCT_CLOSE_SELECT"),
        (target) => {
          this.getAcceptOrderDetailByAcceptOrderNo();
        }
      );
    },

    //納品異常画面を表示
    deliveryExBtnProc() {
      // フォーカス削除
      this.$refs.deliveryExBtn.$el.blur();
      ShowDeliveryExDialog(
        {
          aobQuoteNo: this.acceptEditForm.aobQuoteNo,
          closeStateList: this.closeStateList,
        },
        t("resource.ACCEPT_ORDER.DELIVERY_EX"),
        (target) => {
          this.getAcceptOrderDetailByAcceptOrderNo();
        }
      );
    },

    //セルデータの数字変換
    // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // changeCellDataToNumber(curRow, columnName) {
    changeCellDataToNumber(curRow, columnName, $event) {
      this.selectValue($event);
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      curRow[columnName] = formatCurrencyToNumber(curRow[columnName]);
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.acceptTableData.length - 1) {
        for (var i = 0; i < this.acceptTableData.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < this.acceptTableData.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.acceptTableData.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    //フォームで変更される可能性のアイテムの取得
    extractBasic(data) {
      return {
        aobUserCode: data.aobUserCode,
        aobAcceptState: data.aobAcceptState,
        aobAcceptDate: data.aobAcceptDate,
        // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
        // 一式機能の追加
        aobASet: data.aobASet, //一式
        aobASetProdDrawNo: data.aobASetProdDrawNo, //一式図番
        aobASetProdName: data.aobASetProdName, //一式品名
        aobASetCusOrderNo: data.aobASetCusOrderNo, //一式注番
        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        aobASetSalesPrice: data.aobASetSalesPrice, //一式確定売価
        // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // aobCusDeliveryDate: data.aobCusDeliveryDate,
        // aobCusOrderNo: data.aobCusOrderNo,
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      };
    },
    //テーブルで変更される可能性のある列の取得
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          index: index,
          aodUSetPrice: item.aodUSetPrice,
          aodProdQuantity: item.aodProdQuantity,
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          aodCusDeliveryDate: item.aodCusDeliveryDate,
          aodCusOrderNo: item.aodCusOrderNo,
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          aodDiscussStatus: item.aodDiscussStatus, // 打合状態
          aodUrgentBool: item.aodUrgentBool, // 緊急度
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          aodTreatmentBool: item.aodTreatmentBool, //処理状態
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          aodReduceKbnBool: item.aodReduceKbnBool, // 削減状態
          aodProdShape: item.aodProdShape, // 形状
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
          aodCusDelvCode: item.aodCusDelvCode,
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          aodMisumiNo: item.aodMisumiNo, // ミスミ連携番号
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      var tmpTableData = JSON.parse(JSON.stringify(this.acceptEditForm));
      tmpTableData.aobAcceptDate = formatDateToString(
        tmpTableData.aobAcceptDate
      );
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //   tmpTableData.aobCusDeliveryDate = formatDateToString(
      //   tmpTableData.aobCusDeliveryDate
      // );
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      if (
        (!this.localIsAdd &&
          (!cmpBasicData(
            // UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
            // this.cmpBasicResult,
            // this.extractBasic(tmpTableData)
            JSON.parse(JSON.stringify(this.cmpBasicResult)),
            JSON.parse(JSON.stringify(this.extractBasic(tmpTableData)))
            // UPD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑
          ) ||
            !cmpDetailData(
              // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
              // 納期、注番の変更(見積単位⇒製品単位に変更)
              // this.cmpDetailResult,
              // this.extractDetail(this.acceptTableData)
              JSON.parse(JSON.stringify(this.cmpDetailResult)),
              JSON.parse(
                JSON.stringify(this.extractDetail(this.acceptTableData))
              )
              // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
            ))) ||
        (this.localIsAdd && this.acceptTableData.length > 0)
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      this.acceptTableInfo = [];
      this.acceptTableData.forEach((item, index) => {
        // 見積No.
        var aodQuoteNo = this.acceptEditForm.aobQuoteNo;
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // 受注製品明細No.
        // var aodProdGroupNo = index + 1;
        var aodProdGroupNo = item.aodProdGroupNo;
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        if (item.childrenCount > 1) {
          item.children.forEach((element) => {
            this.saveDataFormat(item, element, aodQuoteNo, aodProdGroupNo);
          });
        } else {
          this.saveDataFormat(item, item, aodQuoteNo, aodProdGroupNo);
        }
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        this.acceptTableInfo.sort((a, b) => {
          return a.aodProdNo - b.aodProdNo;
        });
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      });
    },

    //データを保存のフォーマット
    saveDataFormat(item, element, aodQuoteNo, aodProdGroupNo) {
      this.acceptTableInfo.push({
        aodQuoteNo: aodQuoteNo, // 見積No.
        aodProdNo: element.aodProdNo, // 受注明細No
        aodQuoteChildNo: element.aodQuoteChildNo, // 見積No.子番
        aodProdGroupNo: aodProdGroupNo, // 受注製品明細No.
        aodNdProdNo: element.aodNdProdNo, // 採番明細_見積明細No.
        aodQuoteType: element.aodQuoteType, // 受注タイプ 1:製品、2:設計

        aodProdName: item.aodProdName, // 品名
        aodProdDrawNo: item.aodProdDrawNo, // 図番
        aodProdQuantity: element.aodProdQuantity, // 数量
        aodProdUnit: item.aodProdUnit, // 単位
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 製品の形状の追加
        aodProdShape: item.aodProdShape, // 形状
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // aodProdShape: item.aodProdShape, // 形状
        // aodProdMaterial: item.aodProdMaterial, // 素材
        // aodProdTreatment: item.aodProdTreatment, // 処理
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑

        aodAcceptDate: element.aodAcceptDate, // 受注日
        aodUWeight: item.aodUWeight, //  重量(kg/个)
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
        // 緊急度の追加
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        // aodUrgent: element.aodUrgent, // 緊急度（0:- 1:必須）
        aodUrgent: element.aodUrgentBool ? STR_ONE : STR_ZERO, // 緊急度（0:- 1:必須）
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        aodTreatment: element.aodTreatmentBool ? STR_ONE : STR_ZERO, // 処理　0：存在しない、1：存在
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        aodCusDeliveryDate: formatCurDateToString(item.aodCusDeliveryDate), //得意先納期
        aodCusDeliveryDateHistory: item.aodCusDeliveryDateHistory, //得意先納期履歴

        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        aodCusDelvCode: element.aodCusDelvCode, // 納品先
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 star
        aodMisumiNo: element.aodMisumiNo, // ミスミ連携番号
        aodMisumiKbn: element.aodMisumiKbn, // ミスミ関連区分
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        aodCusOrderNo: item.aodCusOrderNo, //注番
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        aodMSupCode: item.aodMSupCode, // 加工_仕入先コード
        aodMSupDate: item.aodMSupDate, // 加工_仕入先納期
        aodMCurType: item.aodMCurType, // 加工_貨幣タイプ
        aodMExr: item.aodMExr, // 加工_レート
        aodMUPrice: item.aodMUPrice, // 加工_加工単価
        aodMUPriceCny: item.aodMUPriceCny, // 加工_加工単価(CNY)
        aodMTransportCost: item.aodMTransportCost, // 加工_運賃(JPY/kg)
        aodMUTransportCost: item.aodMUTransportCost, // 加工_運賃(JPY/个)
        aodMUTransportCostCny: item.aodMUTransportCostCny, // 加工_運賃(CNY/个)
        aodMCommissionRate: item.aodMCommissionRate, // 加工_提成率（%）
        aodMUCommission: item.aodMUCommission, // 加工_提成(JPY/个)
        aodMUPurchasePrice: item.aodMUPurchasePrice, // 加工_仕入価格(JPY/个)

        aodP1SupCode: item.aodP1SupCode, // 処理1_仕入先コード
        aodP1SupDate: item.aodP1SupDate, // 処理1_仕入先納期
        aodP1CurType: item.aodP1CurType, // 処理1_貨幣タイプ
        aodP1Exr: item.aodP1Exr, // 処理1_レート
        aodP1UPrice: item.aodP1UPrice, // 処理1_加工単価(JPY)
        aodP1TransportCost: item.aodP1TransportCost, // 処理1_運賃(JPY/kg)
        aodP1UTransportCost: item.aodP1UTransportCost, // 処理1_運賃(JPY/个)
        aodP1CommissionRate: item.aodP1CommissionRate, // 処理1_提成率（%）
        aodP1UCommission: item.aodP1UCommission, // 処理1_提成(JPY/个)
        aodP1UPurchasePrice: item.aodP1UPurchasePrice, // 処理1_仕入価格(JPY/个)

        aodP2SupCode: item.aodP2SupCode, // 処理2_仕入先コード
        aodP2SupDate: item.aodP2SupDate, // 処理2_仕入先納期
        aodP2CurType: item.aodP2CurType, // 処理2_貨幣タイプ
        aodP2Exr: item.aodP2Exr, // 処理2_レート
        aodP2UPrice: item.aodP2UPrice, // 処理2_加工単価(JPY)
        aodP2TransportCost: item.aodP2TransportCost, // 処理2_運賃(JPY/kg)
        aodP2UTransportCost: item.aodP2UTransportCost, // 処理2_運賃(JPY/个)
        aodP2CommissionRate: item.aodP2CommissionRate, // 処理2_提成率（%）
        aodP2UCommission: item.aodP2UCommission, // 処理2_提成(JPY/个)
        aodP2UPurchasePrice: item.aodP2UPurchasePrice, // 処理2_仕入価格(JPY/个)

        aodP3SupCode: item.aodP3SupCode, // 処理3_仕入先コード
        aodP3SupDate: item.aodP3SupDate, // 処理3_仕入先納期
        aodP3CurType: item.aodP3CurType, // 処理3_貨幣タイプ
        aodP3Exr: item.aodP3Exr, // 処理3_レート
        aodP3UPrice: item.aodP3UPrice, // 処理3_加工単価(JPY)
        aodP3TransportCost: item.aodP3TransportCost, // 処理3_運賃(JPY/kg)
        aodP3UTransportCost: item.aodP3UTransportCost, // 処理3_運賃(JPY/个)
        aodP3CommissionRate: item.aodP3CommissionRate, // 処理3_提成率（%）
        aodP3UCommission: item.aodP3UCommission, // 処理3_提成(JPY/个)
        aodP3UPurchasePrice: item.aodP3UPurchasePrice, // 処理3_仕入価格(JPY/个)

        aodGrossMargin: item.aodGrossMargin, // 粗利率(%)　0.00～99.99
        aodUSalesPrice: item.aodUSalesPrice, // 売価(JPY/个)：仕入価格(JPY/个) / （1‐粗利率(%)）
        aodUSetPrice: item.aodUSetPrice, // 確定売価(JPY/个)
        aodUGrossProfit: item.aodUGrossProfit, // 粗利(JPY/个)：確定売価（JPY/个）  - 価格(JPY/个)
        aodTotPurchasePrice: item.aodTotPurchasePrice, // 小計仕入金額(JPY)：仕入価格(JPY/个) * 数量
        aodTotSalesPrice: item.aodTotSalesPrice, // 小計売上金額(JPY)：売価（JPY/个） * 数量
        aodTotGrossProfit: item.aodTotGrossProfit, // 小計粗利(JPY)：小計売上（JPY） -  小計原価（JPY）
        aodTotWeight: item.aodTotWeight, // 小計重量(kg)：重量（kg/个） *  数量
        aodProdExKbn: item.aodProdExKbn, // 製品異常区分

        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 start↓
        // 課題_打合状態の追加
        aodDiscussStatus: item.aodDiscussStatus, //打合状態
        // ADD 2025/06/13 ZLL 課題_250610顧客からの改善したい点への対応 end↑
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // aodProdRemarks: element.aodProdRemarks, // 備考　受注製品変更用
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        aodReduceKbn: item.aodReduceKbnBool ? STR_ONE : STR_ZERO, // 削減区分
        aodProdReceExKbn: item.aodProdReceExKbn,
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        aodCloseState: element.aodCloseState,
      });
    },

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考入力のチェック
    // remarksInputProc(row, column) {
    //   //備考以外の場合、何もしない
    //   if (column.prop !== "aodProdRemarks") {
    //     return;
    //   }

    //   if (
    //     column.prop === "aodProdRemarks" &&
    //     row.childrenCount > 1 &&
    //     row.id < 10000
    //   ) {
    //     return false;
    //   }
    //   return true;
    // },
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //Enter処理
    // remarksFocusNextInput(index, columnProp) {
    //   if (columnProp === "aodProdRemarks") {
    //     index = index + 1;
    //     let dataSize = this.acceptTableData.length;

    //     for (let num = 0; num < this.acceptTableData.length; num++) {
    //       const element = this.acceptTableData[num];
    //       dataSize += element.childrenCount;
    //     }

    //     if (index > dataSize - 1) {
    //       for (var i = 0; i < dataSize; i++) {
    //         if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
    //           this.$refs[`input${i}-${columnProp}`][0].focus();
    //           break;
    //         }
    //       }
    //     } else {
    //       var i = index;
    //       for (i; i < dataSize; i++) {
    //         if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
    //           this.$refs[`input${i}-${columnProp}`][0].focus();
    //           break;
    //         }
    //       }
    //       //下に入力ボックスがない場合は、最初から
    //       if (i == dataSize) {
    //         this.focusNextInput(-1, columnProp);
    //       }
    //     }
    //   }
    // },
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)

    //納期コントロール
    cusDeliveryDateInputProc(row, column) {
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
      // 編集列のみコントロールを表示する
      if (
        this.editingList.some((item) => item.value === column.prop) &&
        column.prop != this.editingColumn
      ) {
        return false;
      }
      // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑

      //納期以外の場合、何もしない
      if (column.prop !== "aodCusDeliveryDate") {
        return;
      }
      if (row.id >= 10000) {
        return false;
      }
      return true;
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // 製品数変更
    qtyChangeProc() {
      // フォーカス削除
      this.$refs.qtyChangeBtn.$el.blur();

      ShowProductQtyChangeDialog(
        {
          aobQuoteNo: this.acceptEditForm.aobQuoteNo,
        },
        t("resource.button.quote_qty_change_btn"),
        (target) => {
          this.numLoads = 1;
          this.getAcceptOrderDetailByAcceptOrderNo();
        }
      );
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.aodQuoteNo,
        row.aodProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })

        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            row.aodProdRemarksSum = remarks;
          }
          this.$set(this.acceptTableData, row.index, row);
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },
    //icon
    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.acceptTableData);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      showRemarksDialog(
        this,
        row.aodQuoteNo,
        row.aodProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        this.aodUpdateTime
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            this.aodUpdateTime = res.aodUpdateTime;
            // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
            // 課題_納期分割機能の追加
            this.acceptEditForm.acceptUpdateTime = this.aodUpdateTime;
            // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
            this.$set(this.acceptTableData, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    handleCheckChange(row, prop, val) {
      row[prop] = val ? "1" : "0";
      this.$set(this.acceptTableData, row.index, row);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    showProdEditDialogProc(row, isKbn, event) {
      // フォーカス削除
      event.currentTarget.blur();

      if (!this.showFlag) {
        this.showFlag = true;
      }

      //受注日
      this.acceptEditForm.aobAcceptDate = formatCurDateToString(
        this.acceptEditForm.aobAcceptDate
      );

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      if (this.acceptTableData.length > 0) {
        // 重複しない連携noリストの取得
        const baseMisumiNos = new Set();
        for (const r of this.acceptTableData) {
          if (r.aodMisumiKbn === STR_ZERO || r.aodMisumiKbn === STR_ONE) {
            baseMisumiNos.add(r.aodMisumiNo);
          }
        }

        const DLMisumiNos = new Set();
        for (const r of this.acceptTableData) {
          if (
            (r.aodMisumiKbn === STR_ZERO || r.aodMisumiKbn === STR_ONE) &&
            r.aodMSupFactoryKbn == STR_ONE
          ) {
            DLMisumiNos.add(r.aodMisumiNo);
          }
        }

        for (var index = 0; index < this.acceptTableData.length; index++) {
          const row = this.acceptTableData[index];

          if (
            row.aodMisumiKbn !== STR_ZERO &&
            row.aodMisumiKbn !== STR_ONE &&
            !row.aodReduceKbnBool
          ) {
            // ミスミ連携番号が空のチェック
            if (this.isEmptyOrNull(row.aodMisumiNo)) {
              Modal.showWarning(
                "",
                "製品「" +
                  row.aodProdName +
                  " " +
                  row.aodProdDrawNo +
                  "」の" +
                  t("message.ACCEPT_ORDER.MSM_NO_CHECK"),
                {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                }
              );
              this.showFlag = false;
              return false;
            }

            // ミスミ連携番号が範囲以外の場合
            if (!baseMisumiNos.has(row.aodMisumiNo)) {
              Modal.showWarning(
                "",
                "製品「" +
                  row.aodProdName +
                  " " +
                  row.aodProdDrawNo +
                  "」の" +
                  t("message.ACCEPT_ORDER.MSM_NO_CHECK"),
                {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                }
              );
              this.showFlag = false;
              return false;
            }

            // ミスミ_大連の場合、ミスミ連携番号の仕入先が大連以外の場合、
            if (
              row.aodMisumiKbn == MSM_DL_KBN &&
              !DLMisumiNos.has(row.aodMisumiNo)
            ) {
              Modal.showWarning(
                "",
                "製品「" +
                  row.aodProdName +
                  " " +
                  row.aodProdDrawNo +
                  "」の" +
                  t("message.ACCEPT_ORDER.MSM_DL_NO_CHECK"),
                {
                  confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                }
              );
              this.showFlag = false;
              return false;
            }
          }
        }
      }

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      this.dataAddUpdProc();

      //更新
      updateAcceptOrderDetail({
        curNumberUpdDateTime: this.acceptEditForm.numberUpdateTime,
        curAcceptUpdDateTime: this.acceptEditForm.acceptUpdateTime,
        acceptOrderBasicForm: this.acceptEditForm,
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // acceptOrderDetailInfoList: this.acceptTableData,
        acceptOrderDetailInfoList: this.acceptTableInfo,
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        isOrdered: this.btnNumberInfoFlag,
        user: getUserInfo().UserId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.numLoads = 1;
          this.dueDateEditDialogProc(row, isKbn);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            //検索処理を行う
            this.getAcceptOrderDetailByAcceptOrderNo();
          }
        });
    },

    dueDateEditDialogProc(row, isKbn) {
      const dialogTitles = {
        [STR_ONE]: t("resource.DUE_DATE_EDIT.PROD_SPLIT"),
        [STR_TWO]: t("resource.DUE_DATE_EDIT.PROD_ADD"),
        [STR_THREE]: t("resource.DUE_DATE_EDIT.PROD_CLOSE"),
        [STR_FOUR]: t("resource.DUE_DATE_EDIT.ERR_PROD_ADD"),
        [STR_FIVE]: t("resource.DUE_DATE_EDIT.ERR_PROD_ADD"),
      };

      var dialogTitle = dialogTitles[isKbn] || "";

      ShowDueDateEditDialog(
        {
          rowData: row,
          isKbn: isKbn,
          procKbn: row.aodDataProcKbn,
          aobQuoteNo: this.acceptEditForm.aobQuoteNo,
          aodDataProdNo: row.aodProdNo,
        },
        dialogTitle,

        (target) => {
          this.getAcceptOrderDetailByAcceptOrderNo();
        }
      );
    },

    // ボタンクリック可能のチェック
    buttonCheck(row, btnKbn) {
      // 削減データの場合、分割ボタン、補足ボタン、削減ボタンがクリック不可
      if (row.aodReduceKbnBool || row.aodCloseStateVal != STR_HYPHEN) {
        return true;
      }

      // 分割ボタン
      if (btnKbn === STR_ONE) {
        // 入荷済みの場合、分割ボタンがクリック不可、受注数量が1以下の場合、分割ボタンがクリック不可
        if (
          row.aodRcvStatus === STR_RCV_OVER ||
          row.aodProdQuantity <= NUM_ONE
        ) {
          return true;
        }
      } else {
        if (row.aodOrderStatus != AOB_ORDER_STATUS_ORDERED) {
          return true;
        }

        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 異常品の場合、補足ボタン、削減ボタンがクリック不可
        // if (row.aodProdExKbn != STR_ZERO || row.aodProdReceExKbn !== STR_ZERO) {
        if (
          btnKbn === STR_TWO &&
          // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          // 一式データの場合、「単位」が「式」の製品の補足製品ボタンがクリック不可の変更
          // (row.aodProdExKbn != STR_ZERO || row.aodProdReceExKbn !== STR_ZERO)
          (row.aodProdExKbn != STR_ZERO ||
            row.aodProdReceExKbn !== STR_ZERO ||
            row.aodProdUnit === UNIT_SET)
          // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          return true;
        }

        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 受注数量が1以下の場合、削減ボタンがクリック不可
        // if (btnKbn === STR_THREE && row.aodProdQuantity <= NUM_ONE) {
        if (
          btnKbn === STR_THREE &&
          (row.aodProdQuantity <= NUM_ONE ||
            row.aodRcvStatus === STR_RCV_OVER ||
            row.aodProdExKbn != STR_ZERO)
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          return true;
        }
      }
      return false;
    },

    checkBoxDisableProc(row, column) {
      // if (column.prop === "aodReduceKbnBool" && row.aodProdExKbn === "0") {
      if (column.prop === "aodReduceKbnBool") {
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // if (row.aodProdExKbn === "0" && row.aodProdReceExKbn === STR_ZERO) {
        // 納品異常データの場合、削減区分が選択不可；入荷異常データの場合、削減区分が選択可能
        // 未入荷の場合、選択可能、以外の場合、選択不可
        if (row.aodProdExKbn === "0" && row.aodRcvStatus == STR_NOT_RCV) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          return false;
        }
      }
      return true;
    },

    // 課題_納期分割機能の追加
    changeColumns() {
      this.columns =
        this.quoteType === STR_THREE
          ? this.acceptColumns.filter((col) => {
              return (
                col.prop !== "aodProdExKbnVal" &&
                col.prop !== "aodReduceKbnBool" &&
                col.prop !== "aodCloseStateVal" &&
                col.prop !== "aodRcvStatus" &&
                // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                col.prop !== "aodMisumiNo" && // ミスミ連携番号
                col.prop !== "aodMisumiKbnStr" && // ミスミ関連区分
                // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

                // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                col.prop !== "aodTreatmentBool" // 処理
                // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
              );
            })
          : this.acceptColumns;
    },
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    getAbleDeliveryList(row) {
      return getAbleCusDeliveryList(this.cusDelvList, row.aodCusDelvCode);
    },
    // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

    // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 start↓
    // 一式機能の追加
    handleChange(val) {
      this.aSetDisabledFlg = !val;
      if (!val) {
        this.acceptEditForm.aobASetProdDrawNo = STR_EMPTY;
        this.acceptEditForm.aobASetProdName = STR_EMPTY;
        this.acceptEditForm.aobASetCusOrderNo = STR_EMPTY;
      }
    },

    // ADD 2025/08/07 Wjx 課題_250725顧客からの改善したい点への対応 end↑

    // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
    // 一括至急のチェックボックス
    allUrgentCheckboxChange(checked) {
      this.acceptTableData.forEach((item) => (item.aodUrgentBool = !!checked));
    },

    // 一式確定売価変更
    changeASetSetPrice() {
      this.acceptEditForm.aobASetSalesPrice = formatStringToCurrency(
        this.acceptEditForm.aobASetSalesPrice
      );
    },
    // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

    // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
    //納品先名（表示用）
    getDelvName(code) {
      const delv = this.cusDelvList.find((it) => it.damCode === code);
      return delv ? delv.damName : code;
    },
    // ADD 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
  },
};
</script>
<style scoped>
.editInput {
  width: 90%;
  height: 17px;
  line-height: 0;
}

.el-table__body {
  height: 200px;
}

::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
</style>
